/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.0.0 (NJsonSchema v10.1.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const PLATFORM_API_BASE_URL = new InjectionToken<string>('PLATFORM_API_BASE_URL');

export interface IPlatformClient {
    /**
     * This is internal platform sevices API to migrate Existing scopes to new setup
     * @param authorization Api Key
     * @return OK
     */
    migrateScopes(authorization: string): Observable<any>;
    /**
     * Encrypt Client Secret
     * @param migrationKey (optional) Migration Key
     * @param pages (optional) number of pages
     * @param size (optional) Page Size
     * @return OK
     */
    encryptClientSecretUsingPUT(migrationKey?: string | null | undefined, pages?: number | null | undefined, size?: number | null | undefined): Observable<any>;
    /**
     * Save scopes/permissions for application
     * @param authorization PGA, ABT and JWT ABT tokens
     * @param scopes scopes
     * @param clientId (optional) clientId - required with Platform Admin token
     * @return OK
     */
    saveScopesUsingPUT(authorization: string, scopes: ScopeTO[], clientId?: string | null | undefined): Observable<any>;
    /**
     * Get Role-Permissions map
     * @param authorization PGA, ABT and JWT ABT tokens
     * @param clientId clientId
     * @param roleId roleId
     * @return OK
     */
    getRolePermissionsMappingUsingGET(authorization: string, clientId: string, roleId: string): Observable<any>;
    /**
     * Map Permissions
     * @param authorization PGA, ABT and JWT ABT tokens
     * @param clientId clientId
     * @param permissions permissions
     * @param roleId roleId
     * @return OK
     */
    mapPermissionsUsingPUT(authorization: string, clientId: string, permissions: string[], roleId: string): Observable<any>;
    /**
     * Get Cache objects
     * @param apiKey (optional) Platform internal API Key
     * @param type (optional) Type of cache to retrieve. Valid values: application, messages, config, country, domain, platform, roles, scopes. By default returns application.
     * @return OK
     */
    getCacheUsingGET(apiKey?: string | null | undefined, type?: string | null | undefined): Observable<any>;
    /**
     * Reload individual node cache
     * @param apiKey (optional) Platform internal API Key
     * @param clientID (optional) ClientID
     * @param name (optional) name
     * @return OK
     */
    reloadCacheOnNodeUsingGET(apiKey?: string | null | undefined, clientID?: string | null | undefined, name?: string | null | undefined): Observable<any>;
    /**
     * Reload Cache
     * @param authorization (optional) PGA UBT Token
     * @param apiKey (optional) Platform internal API Key
     * @param name (optional) name
     * @return OK
     */
    reloadCacheUsingPOST(authorization?: string | null | undefined, apiKey?: string | null | undefined, name?: string | null | undefined): Observable<any>;
    /**
     * Reload Cache for given ClientID
     * @param clientID ClientID
     * @param authorization (optional) PGA UBT Token
     * @param apiKey (optional) Platform internal API Key
     * @return OK
     */
    reloadCacheForClientIDUsingPOST(clientID: string, authorization?: string | null | undefined, apiKey?: string | null | undefined): Observable<any>;
    /**
     * Creates custom credentials session & issues authorization code.
     * @param authorization ABT token
     * @param requestObject requestObject
     * @return OK
     */
    impersonationUsingPOST(authorization: string, requestObject: any): Observable<CustomCredentialsTO>;
    /**
     * Verify user password
     * @param authorization ABT token
     * @param dto dto
     * @return User is valid
     */
    validatePasswordUsingPOST(authorization: string, dto: DmapAuthRequestDto): Observable<any>;
    /**
     * Get Service Details for clientID
     * @param authorization ABT, UBT, PGA UBT, JWT UBT and JWT ABT tokens
     * @param clientId Client Id.
     * @param referer (optional) referer
     * @return OK
     */
    getServiceDetailsForClientUsingGET(authorization: string, clientId: string, referer?: string | null | undefined): Observable<any>;
    /**
     * Get platform url for a given enterprise
     * @param domain (optional) domain
     * @param referer (optional) referer
     * @return OK
     */
    getPlatformUrlUsingGET(domain?: string | null | undefined, referer?: string | null | undefined): Observable<any>;
    /**
     * GET Email Filter
     * @param authorization Domain Admin UBT token
     * @param urlPattern Domain URLPattern
     * @return Ok
     */
    getDomainEmailFilterByURLUsingGET(authorization: string, urlPattern: string): Observable<any>;
    /**
     * Get domain information from platform cluster
     * @param authorization ABT and JWT ABT tokens
     * @param domainUID domainUID
     * @return OK
     */
    getDomainInfoFromClusterUsingGET(authorization: string, domainUID: string): Observable<any>;
    /**
     * GET IP Filter
     * @param authorization Domain Admin UBT token
     * @param urlPattern Domain URLPattern
     * @return Ok
     */
    getDomainIPFilterByURLUsingGET(authorization: string, urlPattern: string): Observable<any>;
    /**
     * Get Password Policy for Domain
     * @param authorization Domain Admin UBT
     * @param urlPattern Domain URLPattern
     * @return Ok
     */
    getPasswordPolicyByDomainURLUsingGET(authorization: string, urlPattern: string): Observable<any>;
    /**
     * Get domain information
     * @param authorization ABT, UBT, JWT ABT, JWT UBT and PGA UBT tokens
     * @param domainUID domainUID
     * @return OK
     */
    getUsingGET(authorization: string, domainUID: string): Observable<any>;
    /**
     * GET Email Filter
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @return Ok
     */
    getDomainEmailFilterUsingGET(authorization: string, domainUID: string): Observable<any>;
    /**
     * Create Email Filter
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @param emailFilterTO emailFilterTO
     * @return Ok
     */
    createDomainEmailFilterUsingPOST(authorization: string, domainUID: string, emailFilterTO: EmailFilterTO): Observable<any>;
    /**
     * Update Email Filter
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @param emailFilterTO emailFilterTO
     * @return Ok
     */
    updateDomainEmailFilterUsingPUT(authorization: string, domainUID: string, emailFilterTO: EmailFilterTO): Observable<any>;
    /**
     * Delete Email Filter
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @param emailFilterId Email Filter ID
     * @return Ok
     */
    removeDomainEmailFilterUsingDELETE(authorization: string, domainUID: string, emailFilterId: number): Observable<any>;
    /**
     * GET IP Filter
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @return Ok
     */
    getDomainIPFilterUsingGET(authorization: string, domainUID: string): Observable<any>;
    /**
     * Create IP Filter
     * @param authorization Domain Admin UBT token
     * @param iPFilterTO IPFilterTO
     * @param domainUID domainUID
     * @return Ok
     */
    createDomainIPFilterUsingPOST(authorization: string, iPFilterTO: IPFilterTO, domainUID: string): Observable<any>;
    /**
     * Update IP Filter
     * @param authorization Domain Admin UBT token
     * @param iPFilterTO IPFilterTO
     * @param domainUID domainUID
     * @return Ok
     */
    updateDomainIPFilterUsingPUT(authorization: string, iPFilterTO: IPFilterTO, domainUID: string): Observable<any>;
    /**
     * Delete IP Filter
     * @param authorization Domain Admin UBT token
     * @param iPFilterId IP Filter ID
     * @param domainUID domainUID
     * @return Ok
     */
    removeDomainIPFilterUsingDELETE(authorization: string, iPFilterId: number, domainUID: string): Observable<any>;
    /**
     * Gets organization list
     * @param authorization ABT and JWT ABT tokens
     * @param domainUID domainUID
     * @param limit (optional) Page Size
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @return List of Organizations
     */
    getOrganizationsUsingGET(authorization: string, domainUID: string, limit?: number | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Observable<any>;
    /**
     * Get Password Policy for Domain
     * @param authorization Domain Admin UBT
     * @param domainUID domainUID
     * @return Ok
     */
    getPasswordPolicyUsingGET(authorization: string, domainUID: string): Observable<any>;
    /**
     * Create Password Policy for Domain
     * @param authorization Domain Admin UBT
     * @param domainUID domainUID
     * @param passwordPolicy passwordPolicy
     * @return Ok
     */
    createPasswordPolicyUsingPOST(authorization: string, domainUID: string, passwordPolicy: PasswordPolicyTO): Observable<any>;
    /**
     * Update Password Policy for Domain
     * @param authorization Domain Admin UBT
     * @param domainUID domainUID
     * @param passwordPolicy passwordPolicy
     * @return Ok
     */
    updatePasswordPolicyUsingPUT(authorization: string, domainUID: string, passwordPolicy: PasswordPolicyTO): Observable<any>;
    /**
     * GET domain configuration settings
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @return Ok
     */
    getDomainSettingUsingGET(authorization: string, domainUID: string): Observable<any>;
    /**
     * Update domain configuration settings
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @param settingTO settingTO
     * @return Ok
     */
    setDomainSettingUsingPUT(authorization: string, domainUID: string, settingTO: DomainSettingTO): Observable<any>;
    /**
     * Search impersonation history
     * @param authorization UBT token
     * @param domain domain
     * @param impersonatedUsername (optional) impersonatedUsername
     * @param username (optional) username
     * @return Ok
     */
    searchUsingGET(authorization: string, domain: string, impersonatedUsername?: string | null | undefined, username?: string | null | undefined): Observable<any>;
    /**
     * Get JWT token
     * @param clientId clientId
     * @param clientSecret clientSecret
     * @param psToken psToken
     * @return OK
     */
    getJWTTokenUsingGET(clientId: string, clientSecret: string, psToken: string): Observable<any>;
    /**
     * Get JWT token
     * @param authorization ABT token
     * @param clientId clientId
     * @param expiresInSeconds expiresInSeconds
     * @param payLoad (optional) payLoad
     * @return OK
     */
    generateJWTTokenUsingGET(authorization: string, clientId: string, expiresInSeconds: number, payLoad?: string | null | undefined): Observable<any>;
    /**
     * Generate Report
     * @param apiKey apiKey
     * @return OK
     */
    getSessionStatsUsingPOST(apiKey: string): Observable<any>;
    /**
     * Get all child apps
     * @param authorization ABT token
     * @param clientId (optional) clientId
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @return OK
     */
    getAllChildApplicationsUsingGET(authorization: string, clientId?: string | null | undefined, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Observable<any>;
    /**
     * Create a child app and associate to a parent app
     * @param authorization ABT and JWT ABT tokens
     * @param appTO application
     * @return OK
     */
    createChildApplicationUsingPOST(authorization: string, appTO: ChildAppTO): Observable<any>;
    /**
     * Get child app byId
     * @param authorization ABT token
     * @param clientId Client Id.
     * @return OK
     */
    getChildApplicationUsingGET(authorization: string, clientId: string): Observable<any>;
    /**
     * Update a child app
     * @param authorization ABT token
     * @param appTO application
     * @param clientId clientId
     * @return OK
     */
    updateChildApplicationUsingPUT(authorization: string, appTO: ChildAppTO, clientId: string): Observable<any>;
    /**
     * Delete child app byId
     * @param authorization ABT token
     * @param clientId Client Id.
     * @return OK
     */
    removeChildApplicationUsingDELETE(authorization: string, clientId: string): Observable<any>;
    /**
     * Rotate Secret Key
     * @param authorization ABT token
     * @param clientId clientId
     * @return OK
     */
    rotateUsingPUT(authorization: string, clientId: string): Observable<any>;
    /**
     * Get group/role user stats
     * @param authorization ABT and JWT ABT tokens
     * @param roleId (optional) roleId --> for strategy roles
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    getStatsUsingGET(authorization: string, roleId?: string | null | undefined, strategy?: string | null | undefined): Observable<any>;
    /**
     * Save an organization
     * @param authorization UBT token
     * @param organization organization
     * @param landingPageUrl (optional) landingPageUrl
     * @return OK
     */
    saveUsingPOST(authorization: string, organization: OrganizationTO, landingPageUrl?: string | null | undefined): Observable<any>;
    /**
     * Updates an organization
     * @param authorization UBT token
     * @param organization organization
     * @return Organization updated
     */
    updateUsingPUT(authorization: string, organization: OrganizationTO): Observable<OrganizationTO>;
    /**
     * Get workgroup admins
     * @param authorization UBT and JWT UBT tokens
     * @param orgId OrgId
     * @return Ok
     */
    getWorkGroupAdmins(authorization: string, orgId: string): Observable<any>;
    /**
     * Assign Workgroup admin role
     * @param authorization JWT UBT token
     * @param orgId OrgId
     * @param emailIds emailIds
     * @param collaborationDomain (optional) collaborationDomain
     * @param collaboratorType (optional) collaboratorType
     * @return Updated
     */
    addWorkGroupAdmin(authorization: string, orgId: string, emailIds: string[], collaborationDomain?: string | null | undefined, collaboratorType?: string | null | undefined): Observable<any>;
    /**
     * Revoke Role workgroup admin role
     * @param authorization JWT UBT token
     * @param orgId OrgId
     * @param emailIds emailIds
     * @param collaborationDomain (optional) collaborationDomain
     * @param collaboratorType (optional) collaboratorType
     * @return OK
     */
    removeWorkGroupAdmin(authorization: string, orgId: string, emailIds: string[], collaborationDomain?: string | null | undefined, collaboratorType?: string | null | undefined): Observable<any>;
    /**
     * Assign role
     * @param authorization JWT UBT token
     * @param orgId OrgId
     * @param emailIds emailIds
     * @param id id
     * @param collaborationDomain (optional) collaborationDomain
     * @param collaboratorType (optional) collaboratorType
     * @return Updated
     */
    addUserRole(authorization: string, orgId: string, emailIds: string[], id: string, collaborationDomain?: string | null | undefined, collaboratorType?: string | null | undefined): Observable<any>;
    /**
     * Remove Role
     * @param authorization JWT UBT token
     * @param orgId OrgId
     * @param emailIds emailIds
     * @param id id
     * @param collaborationDomain (optional) collaborationDomain
     * @param collaboratorType (optional) collaboratorType
     * @return OK
     */
    removeUserRole(authorization: string, orgId: string, emailIds: string[], id: string, collaborationDomain?: string | null | undefined, collaboratorType?: string | null | undefined): Observable<any>;
    /**
     * Get user details for a user within the org
     * @param authorization UBT and JWT UBT tokens
     * @param orgId OrgId
     * @param pGuid pGuid
     * @return List of users
     */
    getUserDetails(authorization: string, orgId: string, pGuid: string): Observable<any>;
    /**
     * Get User Roles
     * @param authorization UBT and JWT UBT tokens
     * @param orgId OrgId
     * @param pGuid pGuid
     * @return List of Roles
     */
    getUserRoles(authorization: string, orgId: string, pGuid: string): Observable<any>;
    /**
     * Gets invited users list
     * @param authorization UBT token
     * @param id id
     * @param invitationStatus (optional) invitationStatus
     * @param limit (optional) Page Size
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    getInvitedUsersUsingGET(authorization: string, id: string, invitationStatus?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined, strategy?: string | null | undefined): Observable<any>;
    /**
     * Get Roles registered by all applications
     * @param authorization UBT (Domain admin or workgroup admin)
     * @param id id
     * @param domain (optional) domain
     * @return List of Roles
     */
    getAppRolesForOrg(authorization: string, id: string, domain?: string | null | undefined): Observable<any>;
    /**
     * DELETE users from workgroup
     * @param authorization JWT UBT token
     * @param emailIds emailIds
     * @param id id
     * @param isRemoveWorkGroupAdministrator (optional) true/false Default: false
     * @return OK
     */
    removeUsersInOrgUsingDELETE(authorization: string, emailIds: string[], id: string, isRemoveWorkGroupAdministrator?: string | null | undefined): Observable<any>;
    /**
     * Get users list within the organization
     * @param authorization ABT, UBT token
     * @param id id
     * @param firstname (optional) firstname
     * @param lastname (optional) lastname
     * @param limit (optional) Page Size
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @param username (optional) username
     * @return OK
     */
    getUsersUsingGET(authorization: string, id: string, firstname?: string | null | undefined, lastname?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined, strategy?: string | null | undefined, username?: string | null | undefined): Observable<any>;
    /**
     * Get Permissions
     * @param authorization ABT, JWT ABT tokens
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @return OK
     */
    getAllPermissionsUsingGET(authorization: string, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Observable<any>;
    /**
     * Register/Create a role for an app: Required field: name
     * @param authorization JWT ABT token
     * @param roleTO roleTO
     * @return OK
     */
    saveRole(authorization: string, roleTO: RoleTO): Observable<any>;
    /**
     * Get Roles registered by all applications
     * @param authorization ABT and JWT ABT tokens
     * @param domain (optional) domain
     * @return List of Roles
     */
    getApplicationRoles(authorization: string, domain?: string | null | undefined): Observable<any>;
    /**
     * Get Roles defined for an Application
     * @param authorization JWT ABT token
     * @param id id
     * @return List of Roles
     */
    getRoles(authorization: string, id: string): Observable<any>;
    /**
     * Update role for an app
     * @param authorization JWT ABT token
     * @param id id
     * @param roleTO roleTO
     * @return Updated
     */
    updateRole(authorization: string, id: string, roleTO: RoleTO): Observable<any>;
    /**
     * Delete Role for a given Application
     * @param authorization JWT ABT token
     * @param id id
     * @return deleted
     */
    deleteRole(authorization: string, id: string): Observable<any>;
    /**
     * Scope Lookup service
     * @param clientId (optional) clientId
     * @param name (optional) name
     * @param namespace (optional) namespace
     * @return OK
     */
    lookupService(clientId?: string | null | undefined, name?: string | null | undefined, namespace?: string | null | undefined): Observable<any>;
    /**
     * Add scope to an app
     * @param authorization ABT Token
     * @param scopeRegistryTO scopeRegistryTO
     * @return OK
     */
    addScopeForApp(authorization: string, scopeRegistryTO: ScopeRegistryTO): Observable<any>;
    /**
     * Delete scope
     * @param authorization ABT Token
     * @param id id
     * @return OK
     */
    deleteScope(authorization: string, id: number): Observable<any>;
    /**
     * Login: Perform authentication (Grant type: Password by default)
     * @param authorization Basic Base64ENCODED(username:password)
     * @param grant_type grant_type
     * @param requestObject requestObject
     * @return OK
     */
    authenticateUsingPOST(authorization: string, grant_type: string, requestObject: any): Observable<any>;
    /**
     * Update workgroupId for the session (user must be part of workgroup)
     * @param authorization UBT token
     * @param requestObject requestObject
     * @return OK
     */
    updateOrgIdUsingPUT(authorization: string, requestObject: { [key: string]: string; }): Observable<any>;
    /**
     * Invalidate Token
     * @param access_token access_token
     * @param clientId (optional) clientId
     * @return OK
     */
    invalidateTokenUsingDELETE(access_token: string, clientId?: string | null | undefined): Observable<any>;
    /**
     * Get sessionGuid
     * @param authorization ABT, UBT, ABT JWT, JWT UBT, PGA UBT tokens
     * @param pSessionGuid pSessionGuid
     * @return OK
     */
    getProxySessionUsingGET(authorization: string, pSessionGuid: string): Observable<any>;
    /**
     * Get JWT token for ABT or UBT access_token or psToken issued by platform
     * @param authorization ABT, UBT, JWT ABT, JWT UBT, PGA UBT tokens
     * @param access_token access_token
     * @param audience audience
     * @return OK
     */
    getTokenUsingGET(authorization: string, access_token: string, audience: string): Observable<any>;
    /**
     * Terminate user's own tokens
     * @param authorization UBT token
     * @param access_token access_token
     * @return OK
     */
    terminateUsingDELETE(authorization: string, access_token: string): Observable<any>;
    /**
     * Get the session details for the access_token
     * @param access_token access_token
     * @param clientId (optional) clientId
     * @param domain (optional) domain
     * @return OK
     */
    validateRawTokenUsingPOST(access_token: string, clientId?: string | null | undefined, domain?: string | null | undefined): Observable<any>;
    /**
     * Get the session details for the access_token
     * @param authorization Basic BASE64ENCODED(clientId:clientSecret)
     * @param access_token access_token
     * @param domain (optional) domain
     * @return OK
     */
    validateTokenUsingGET(authorization: string, access_token: string, domain?: string | null | undefined): Observable<any>;
    /**
     * Track User session
     * @param authorization UBT token
     * @param clientId clientId
     * @param lastAccessSync (optional) Time elapsed (in seconds) since last user activity
     * @return OK
     */
    trackSessionUsingPUT(authorization: string, clientId: string, lastAccessSync?: number | null | undefined): Observable<any>;
    /**
     * Check idle timeout
     * @param authorization UBT and JWT UBT tokens
     * @return OK
     */
    isIdleUsingGET(authorization: string): Observable<any>;
    /**
     * Check Health
     * @return OK
     */
    health(): Observable<any>;
    /**
     * Get jwtv2 token
     * @param grant_type grant_type
     * @param authorization (optional) Basic BASE64ENCODED(clientId:clientSecret) or Basic BASE64ENCODED(clientId:userApiKey)
     * @param assertion (optional) assertion
     * @param audience (optional) audience
     * @param data (optional) data
     * @param refresh_token (optional) refresh_token
     * @param scope (optional) scope
     * @return OK
     */
    getJWTTokenUsingPOST(grant_type: string, authorization?: string | null | undefined, assertion?: string | null | undefined, audience?: string | null | undefined, data?: any | null | undefined, refresh_token?: string | null | undefined, scope?: string | null | undefined): Observable<any>;
    /**
     * Terminate JWT Token
     * @param authorization Basic BASE64ENCODED(clientId:clientSecret) or PGA tokens
     * @param access_token access_token
     * @return OK
     */
    deleteUsingDELETE(authorization: string, access_token: string): Observable<any>;
    /**
     * Generate assertion token
     * @param authorization UBT token
     * @param issuer issuer
     * @param audience (optional) audience
     * @param mem (optional) mem
     * @return OK
     */
    generateAssertion(authorization: string, issuer: string, audience?: string | null | undefined, mem?: string[] | null | undefined): Observable<any>;
    /**
     * Generate impersonated assertion token with application credentials.
     * @param authorization Basic BASE64ENCODED(clientId:clientSecret)
     * @param acl (optional) acl
     * @param cwid (optional) cwid
     * @param mem (optional) mem
     * @param membershipType (optional) membershipType
     * @param tsd (optional) TrustedClaims
     * @param uid (optional) uid
     * @return OK
     */
    generateClientImpersonationAssertionUsingPOST(authorization: string, acl?: string[] | null | undefined, cwid?: string | null | undefined, mem?: string[] | null | undefined, membershipType?: MembershipType | null | undefined, tsd?: any | null | undefined, uid?: string | null | undefined): Observable<any>;
    /**
     * Register a new user for the domain
     * @param authorization ABT and PGA UBT tokens
     * @param activationLink activationLink
     * @param user user
     * @param skipEmail (optional) skipEmail
     * @return OK
     */
    createUsingPOST(authorization: string, activationLink: string, user: UserTO, skipEmail?: string | null | undefined): Observable<any>;
    /**
     * Get User Activity
     * @param authorization UBT token
     * @return OK
     */
    getUserActivityUsingGET(authorization: string): Observable<any>;
    /**
     * GET ApiKeys for the user
     * @param authorization UBT token
     * @return OK
     */
    getAllUsingGET(authorization: string): Observable<any>;
    /**
     * Save ApiKey for the user
     * @param authorization UBT token
     * @param userAPIKeyMapTO userAPIKeyMapTO
     * @return OK
     */
    saveV2UsingPOST(authorization: string, userAPIKeyMapTO: UserAPIKeyMapTO): Observable<any>;
    /**
     * Save ApiKey for the user
     * @param authorization UBT token
     * @return OK
     */
    saveUsingPUT(authorization: string): Observable<any>;
    /**
     * DELETE All ApiKeys
     * @param authorization UBT token
     * @return OK
     */
    deleteAllUsingDELETE(authorization: string): Observable<any>;
    /**
     * ApiKeyMigration
     * @param authorization PGA token
     * @return OK
     */
    migrateUsingPOST(authorization: string): Observable<any>;
    /**
     * Get organizations for list of users with ABT token
     * @param authorization ABT token
     * @param pGuids pGuids
     * @return OK
     */
    getAllUserOrgsDomainsUsingPOST(authorization: string, pGuids: string[]): Observable<any>;
    /**
     * Get long-running and active user session with UBT
     * @param authorization UBT and PGA UBT tokens
     * @return OK
     */
    getUserSessionsUsingGET(authorization: string): Observable<any>;
    /**
     * ${User.getLastOrgId.APIOperation}
     * @param authorization ${User.getLastOrgId.Authorization}
     * @return OK
     */
    getLastOrgIdUsingGET(authorization: string): Observable<any>;
    /**
     * resendConfirmation
     * @param requestObject requestObject
     * @return OK
     */
    resendConfirmationUsingPOST(requestObject: any): Observable<any>;
    /**
     * Activates the user
     * @param authorization ABT token
     * @param defaultHomePageUrl defaultHomePageUrl
     * @param domain domain
     * @param key key
     * @return OK
     */
    verifyEmailAddressUsingPOST(authorization: string, defaultHomePageUrl: string, domain: string, key: string): Observable<any>;
    /**
     * Disable the user
     * @param authorization ABT token
     * @param pGuid pGuid
     * @return OK
     */
    disableUserUsingDELETE(authorization: string, pGuid: string): Observable<any>;
    /**
     * Get organizations with ABT token
     * @param authorization ABT and JWT ABT tokens
     * @param pGuid pGuid
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    getOrganizationsWithABTUsingGET(authorization: string, pGuid: string, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined, strategy?: string | null | undefined): Observable<any>;
    /**
     * Gets organizations with roles
     * @param authorization ABT, UBT, JWT UBT, JWT ABT and PGA UBT tokens
     * @param pGuid pGuid
     * @return OK
     */
    getOrganizationRolesUsingGET(authorization: string, pGuid: string): Observable<any>;
    /**
     * Adds a permission to a user
     * @param authorization Authorization
     * @param id id
     * @param pGuid pGuid
     * @return OK
     */
    addPermissionUsingPUT(authorization: string, id: string, pGuid: string): Observable<any>;
    /**
     * Removes a permission for a user
     * @param authorization Authorization
     * @param id id
     * @param pGuid pGuid
     * @return OK
     */
    removePermissionUsingDELETE(authorization: string, id: string, pGuid: string): Observable<any>;
    /**
     * Get User Permissions
     * @param authorization ABT token
     * @param pGuid pGuid
     * @param clientId (optional) clientId
     * @return OK
     */
    getAllUserPermissionsUsingGET(authorization: string, pGuid: string, clientId?: string | null | undefined): Observable<any>;
    /**
     * Get long-running and active user session for given pGuid
     * @param authorization UBT and PGA UBT tokens
     * @param pGuid pGuid
     * @return OK
     */
    getUserSessionBypGuidUsingGET(authorization: string, pGuid: string): Observable<any>;
    /**
     * health
     * @return OK
     */
    healthUsingGET(): Observable<any>;
    /**
     * Generate assertion token
     * @param authorization (optional) UBT token
     * @param x_API_Key (optional) Base 64 encoded clientID:APIKey
     * @param acl (optional) acl
     * @param audience (optional) audience
     * @param cwid (optional) cwid
     * @param issuer (optional) issuer
     * @param mem (optional) mem
     * @return OK
     */
    generateAssertionUsingPOST(authorization?: string | null | undefined, x_API_Key?: string | null | undefined, acl?: string[] | null | undefined, audience?: string | null | undefined, cwid?: string | null | undefined, issuer?: string | null | undefined, mem?: string[] | null | undefined): Observable<any>;
    /**
     * Generate assertion token
     * @param authorization Basic BASE64ENCODED(clientId:clientSecret)
     * @param tsd TrustedClaims
     * @param x_API_Key (optional) Base 64 encoded clientID:APIKey
     * @param acl (optional) acl
     * @param audience (optional) audience
     * @param cwid (optional) cwid
     * @param mem (optional) mem
     * @param membershipType (optional) membershipType
     * @param psToken (optional) psToken
     * @return OK
     */
    generateAssertionV3UsingPOST(authorization: string, tsd: any, x_API_Key?: string | null | undefined, acl?: string[] | null | undefined, audience?: string | null | undefined, cwid?: string | null | undefined, mem?: string[] | null | undefined, membershipType?: MembershipType2 | null | undefined, psToken?: string | null | undefined): Observable<any>;
    /**
     * version
     * @return OK
     */
    versionUsingGET(): Observable<any>;
}

@Injectable()
export class PlatformClient implements IPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * This is internal platform sevices API to migrate Existing scopes to new setup
     * @param authorization Api Key
     * @return OK
     */
    migrateScopes(authorization: string): Observable<any> {
        let url_ = this.baseUrl + "/Application/Scope/";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrateScopes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateScopes(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processMigrateScopes(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Encrypt Client Secret
     * @param migrationKey (optional) Migration Key
     * @param pages (optional) number of pages
     * @param size (optional) Page Size
     * @return OK
     */
    encryptClientSecretUsingPUT(migrationKey?: string | null | undefined, pages?: number | null | undefined, size?: number | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Applications/EncryptClientSecrets?";
        if (pages !== undefined)
            url_ += "pages=" + encodeURIComponent("" + pages) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "migrationKey": migrationKey !== undefined && migrationKey !== null ? "" + migrationKey : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEncryptClientSecretUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEncryptClientSecretUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processEncryptClientSecretUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Save scopes/permissions for application
     * @param authorization PGA, ABT and JWT ABT tokens
     * @param scopes scopes
     * @param clientId (optional) clientId - required with Platform Admin token
     * @return OK
     */
    saveScopesUsingPUT(authorization: string, scopes: ScopeTO[], clientId?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Applications/Scopes?";
        if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scopes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveScopesUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveScopesUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processSaveScopesUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get Role-Permissions map
     * @param authorization PGA, ABT and JWT ABT tokens
     * @param clientId clientId
     * @param roleId roleId
     * @return OK
     */
    getRolePermissionsMappingUsingGET(authorization: string, clientId: string, roleId: string): Observable<any> {
        let url_ = this.baseUrl + "/Applications/{clientId}/{roleId}/Permissions";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId)); 
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolePermissionsMappingUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolePermissionsMappingUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetRolePermissionsMappingUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Map Permissions
     * @param authorization PGA, ABT and JWT ABT tokens
     * @param clientId clientId
     * @param permissions permissions
     * @param roleId roleId
     * @return OK
     */
    mapPermissionsUsingPUT(authorization: string, clientId: string, permissions: string[], roleId: string): Observable<any> {
        let url_ = this.baseUrl + "/Applications/{clientId}/{roleId}/Permissions";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId)); 
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMapPermissionsUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMapPermissionsUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processMapPermissionsUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get Cache objects
     * @param apiKey (optional) Platform internal API Key
     * @param type (optional) Type of cache to retrieve. Valid values: application, messages, config, country, domain, platform, roles, scopes. By default returns application.
     * @return OK
     */
    getCacheUsingGET(apiKey?: string | null | undefined, type?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Cache/?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "apiKey": apiKey !== undefined && apiKey !== null ? "" + apiKey : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCacheUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCacheUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetCacheUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Reload individual node cache
     * @param apiKey (optional) Platform internal API Key
     * @param clientID (optional) ClientID
     * @param name (optional) name
     * @return OK
     */
    reloadCacheOnNodeUsingGET(apiKey?: string | null | undefined, clientID?: string | null | undefined, name?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Cache/Node/Reload?";
        if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "apiKey": apiKey !== undefined && apiKey !== null ? "" + apiKey : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReloadCacheOnNodeUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReloadCacheOnNodeUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processReloadCacheOnNodeUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Reload Cache
     * @param authorization (optional) PGA UBT Token
     * @param apiKey (optional) Platform internal API Key
     * @param name (optional) name
     * @return OK
     */
    reloadCacheUsingPOST(authorization?: string | null | undefined, apiKey?: string | null | undefined, name?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Cache/Reload?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "apiKey": apiKey !== undefined && apiKey !== null ? "" + apiKey : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReloadCacheUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReloadCacheUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processReloadCacheUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Reload Cache for given ClientID
     * @param clientID ClientID
     * @param authorization (optional) PGA UBT Token
     * @param apiKey (optional) Platform internal API Key
     * @return OK
     */
    reloadCacheForClientIDUsingPOST(clientID: string, authorization?: string | null | undefined, apiKey?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Cache/{clientID}/Reload";
        if (clientID === undefined || clientID === null)
            throw new Error("The parameter 'clientID' must be defined.");
        url_ = url_.replace("{clientID}", encodeURIComponent("" + clientID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "apiKey": apiKey !== undefined && apiKey !== null ? "" + apiKey : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReloadCacheForClientIDUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReloadCacheForClientIDUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processReloadCacheForClientIDUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Creates custom credentials session & issues authorization code.
     * @param authorization ABT token
     * @param requestObject requestObject
     * @return OK
     */
    impersonationUsingPOST(authorization: string, requestObject: any): Observable<CustomCredentialsTO> {
        let url_ = this.baseUrl + "/CustomCredential/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestObject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonationUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonationUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<CustomCredentialsTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomCredentialsTO>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonationUsingPOST(response: HttpResponseBase): Observable<CustomCredentialsTO> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomCredentialsTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CustomCredentialsTO.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Precondition Failed. User expired / user locked", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomCredentialsTO>(<any>null);
    }

    /**
     * Verify user password
     * @param authorization ABT token
     * @param dto dto
     * @return User is valid
     */
    validatePasswordUsingPOST(authorization: string, dto: DmapAuthRequestDto): Observable<any> {
        let url_ = this.baseUrl + "/DMAPAuthentication/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePasswordUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePasswordUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processValidatePasswordUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Already exists", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get Service Details for clientID
     * @param authorization ABT, UBT, PGA UBT, JWT UBT and JWT ABT tokens
     * @param clientId Client Id.
     * @param referer (optional) referer
     * @return OK
     */
    getServiceDetailsForClientUsingGET(authorization: string, clientId: string, referer?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Discovery/Application/{clientId}?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId)); 
        if (referer !== undefined)
            url_ += "referer=" + encodeURIComponent("" + referer) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceDetailsForClientUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceDetailsForClientUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceDetailsForClientUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get platform url for a given enterprise
     * @param domain (optional) domain
     * @param referer (optional) referer
     * @return OK
     */
    getPlatformUrlUsingGET(domain?: string | null | undefined, referer?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Discovery/Platform?";
        if (domain !== undefined)
            url_ += "domain=" + encodeURIComponent("" + domain) + "&"; 
        if (referer !== undefined)
            url_ += "referer=" + encodeURIComponent("" + referer) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatformUrlUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatformUrlUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlatformUrlUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * GET Email Filter
     * @param authorization Domain Admin UBT token
     * @param urlPattern Domain URLPattern
     * @return Ok
     */
    getDomainEmailFilterByURLUsingGET(authorization: string, urlPattern: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/EmailFilters/?";
        if (urlPattern === undefined || urlPattern === null)
            throw new Error("The parameter 'urlPattern' must be defined and cannot be null.");
        else
            url_ += "urlPattern=" + encodeURIComponent("" + urlPattern) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomainEmailFilterByURLUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomainEmailFilterByURLUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetDomainEmailFilterByURLUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get domain information from platform cluster
     * @param authorization ABT and JWT ABT tokens
     * @param domainUID domainUID
     * @return OK
     */
    getDomainInfoFromClusterUsingGET(authorization: string, domainUID: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/Global/{domainUID}";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomainInfoFromClusterUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomainInfoFromClusterUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetDomainInfoFromClusterUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * GET IP Filter
     * @param authorization Domain Admin UBT token
     * @param urlPattern Domain URLPattern
     * @return Ok
     */
    getDomainIPFilterByURLUsingGET(authorization: string, urlPattern: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/IPFilters/?";
        if (urlPattern === undefined || urlPattern === null)
            throw new Error("The parameter 'urlPattern' must be defined and cannot be null.");
        else
            url_ += "urlPattern=" + encodeURIComponent("" + urlPattern) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomainIPFilterByURLUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomainIPFilterByURLUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetDomainIPFilterByURLUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get Password Policy for Domain
     * @param authorization Domain Admin UBT
     * @param urlPattern Domain URLPattern
     * @return Ok
     */
    getPasswordPolicyByDomainURLUsingGET(authorization: string, urlPattern: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/PwdPolicy?";
        if (urlPattern === undefined || urlPattern === null)
            throw new Error("The parameter 'urlPattern' must be defined and cannot be null.");
        else
            url_ += "urlPattern=" + encodeURIComponent("" + urlPattern) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordPolicyByDomainURLUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordPolicyByDomainURLUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetPasswordPolicyByDomainURLUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get domain information
     * @param authorization ABT, UBT, JWT ABT, JWT UBT and PGA UBT tokens
     * @param domainUID domainUID
     * @return OK
     */
    getUsingGET(authorization: string, domainUID: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * GET Email Filter
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @return Ok
     */
    getDomainEmailFilterUsingGET(authorization: string, domainUID: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/EmailFilters";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomainEmailFilterUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomainEmailFilterUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetDomainEmailFilterUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Create Email Filter
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @param emailFilterTO emailFilterTO
     * @return Ok
     */
    createDomainEmailFilterUsingPOST(authorization: string, domainUID: string, emailFilterTO: EmailFilterTO): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/EmailFilters";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailFilterTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDomainEmailFilterUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDomainEmailFilterUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDomainEmailFilterUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Update Email Filter
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @param emailFilterTO emailFilterTO
     * @return Ok
     */
    updateDomainEmailFilterUsingPUT(authorization: string, domainUID: string, emailFilterTO: EmailFilterTO): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/EmailFilters";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailFilterTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDomainEmailFilterUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDomainEmailFilterUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDomainEmailFilterUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Delete Email Filter
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @param emailFilterId Email Filter ID
     * @return Ok
     */
    removeDomainEmailFilterUsingDELETE(authorization: string, domainUID: string, emailFilterId: number): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/EmailFilters?";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        if (emailFilterId === undefined || emailFilterId === null)
            throw new Error("The parameter 'emailFilterId' must be defined and cannot be null.");
        else
            url_ += "emailFilterId=" + encodeURIComponent("" + emailFilterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDomainEmailFilterUsingDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDomainEmailFilterUsingDELETE(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveDomainEmailFilterUsingDELETE(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * GET IP Filter
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @return Ok
     */
    getDomainIPFilterUsingGET(authorization: string, domainUID: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/IPFilters";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomainIPFilterUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomainIPFilterUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetDomainIPFilterUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Create IP Filter
     * @param authorization Domain Admin UBT token
     * @param iPFilterTO IPFilterTO
     * @param domainUID domainUID
     * @return Ok
     */
    createDomainIPFilterUsingPOST(authorization: string, iPFilterTO: IPFilterTO, domainUID: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/IPFilters";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iPFilterTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDomainIPFilterUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDomainIPFilterUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDomainIPFilterUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Update IP Filter
     * @param authorization Domain Admin UBT token
     * @param iPFilterTO IPFilterTO
     * @param domainUID domainUID
     * @return Ok
     */
    updateDomainIPFilterUsingPUT(authorization: string, iPFilterTO: IPFilterTO, domainUID: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/IPFilters";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iPFilterTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDomainIPFilterUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDomainIPFilterUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDomainIPFilterUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Delete IP Filter
     * @param authorization Domain Admin UBT token
     * @param iPFilterId IP Filter ID
     * @param domainUID domainUID
     * @return Ok
     */
    removeDomainIPFilterUsingDELETE(authorization: string, iPFilterId: number, domainUID: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/IPFilters?";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        if (iPFilterId === undefined || iPFilterId === null)
            throw new Error("The parameter 'iPFilterId' must be defined and cannot be null.");
        else
            url_ += "IPFilterId=" + encodeURIComponent("" + iPFilterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDomainIPFilterUsingDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDomainIPFilterUsingDELETE(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveDomainIPFilterUsingDELETE(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Gets organization list
     * @param authorization ABT and JWT ABT tokens
     * @param domainUID domainUID
     * @param limit (optional) Page Size
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @return List of Organizations
     */
    getOrganizationsUsingGET(authorization: string, domainUID: string, limit?: number | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/Organizations?";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&"; 
        if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&"; 
        if (sortDir !== undefined)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationsUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationsUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationsUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get Password Policy for Domain
     * @param authorization Domain Admin UBT
     * @param domainUID domainUID
     * @return Ok
     */
    getPasswordPolicyUsingGET(authorization: string, domainUID: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/PwdPolicy";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordPolicyUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordPolicyUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetPasswordPolicyUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Create Password Policy for Domain
     * @param authorization Domain Admin UBT
     * @param domainUID domainUID
     * @param passwordPolicy passwordPolicy
     * @return Ok
     */
    createPasswordPolicyUsingPOST(authorization: string, domainUID: string, passwordPolicy: PasswordPolicyTO): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/PwdPolicy";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(passwordPolicy);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePasswordPolicyUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePasswordPolicyUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePasswordPolicyUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Update Password Policy for Domain
     * @param authorization Domain Admin UBT
     * @param domainUID domainUID
     * @param passwordPolicy passwordPolicy
     * @return Ok
     */
    updatePasswordPolicyUsingPUT(authorization: string, domainUID: string, passwordPolicy: PasswordPolicyTO): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/PwdPolicy";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(passwordPolicy);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePasswordPolicyUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePasswordPolicyUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePasswordPolicyUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * GET domain configuration settings
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @return Ok
     */
    getDomainSettingUsingGET(authorization: string, domainUID: string): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/Settings";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomainSettingUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomainSettingUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetDomainSettingUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Update domain configuration settings
     * @param authorization Domain Admin UBT token
     * @param domainUID domainUID
     * @param settingTO settingTO
     * @return Ok
     */
    setDomainSettingUsingPUT(authorization: string, domainUID: string, settingTO: DomainSettingTO): Observable<any> {
        let url_ = this.baseUrl + "/Domain/{domainUID}/Settings";
        if (domainUID === undefined || domainUID === null)
            throw new Error("The parameter 'domainUID' must be defined.");
        url_ = url_.replace("{domainUID}", encodeURIComponent("" + domainUID)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settingTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDomainSettingUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDomainSettingUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processSetDomainSettingUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Search impersonation history
     * @param authorization UBT token
     * @param domain domain
     * @param impersonatedUsername (optional) impersonatedUsername
     * @param username (optional) username
     * @return Ok
     */
    searchUsingGET(authorization: string, domain: string, impersonatedUsername?: string | null | undefined, username?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Impersonation/Search?";
        if (domain === undefined || domain === null)
            throw new Error("The parameter 'domain' must be defined and cannot be null.");
        else
            url_ += "domain=" + encodeURIComponent("" + domain) + "&"; 
        if (impersonatedUsername !== undefined)
            url_ += "impersonatedUsername=" + encodeURIComponent("" + impersonatedUsername) + "&"; 
        if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processSearchUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get JWT token
     * @param clientId clientId
     * @param clientSecret clientSecret
     * @param psToken psToken
     * @return OK
     */
    getJWTTokenUsingGET(clientId: string, clientSecret: string, psToken: string): Observable<any> {
        let url_ = this.baseUrl + "/JWT/Token?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&"; 
        if (clientSecret === undefined || clientSecret === null)
            throw new Error("The parameter 'clientSecret' must be defined and cannot be null.");
        else
            url_ += "clientSecret=" + encodeURIComponent("" + clientSecret) + "&"; 
        if (psToken === undefined || psToken === null)
            throw new Error("The parameter 'psToken' must be defined and cannot be null.");
        else
            url_ += "psToken=" + encodeURIComponent("" + psToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJWTTokenUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJWTTokenUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetJWTTokenUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get JWT token
     * @param authorization ABT token
     * @param clientId clientId
     * @param expiresInSeconds expiresInSeconds
     * @param payLoad (optional) payLoad
     * @return OK
     */
    generateJWTTokenUsingGET(authorization: string, clientId: string, expiresInSeconds: number, payLoad?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/JWT/Token/{clientId}?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId)); 
        if (expiresInSeconds === undefined || expiresInSeconds === null)
            throw new Error("The parameter 'expiresInSeconds' must be defined and cannot be null.");
        else
            url_ += "expiresInSeconds=" + encodeURIComponent("" + expiresInSeconds) + "&"; 
        if (payLoad !== undefined)
            url_ += "payLoad=" + encodeURIComponent("" + payLoad) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateJWTTokenUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateJWTTokenUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateJWTTokenUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Generate Report
     * @param apiKey apiKey
     * @return OK
     */
    getSessionStatsUsingPOST(apiKey: string): Observable<any> {
        let url_ = this.baseUrl + "/Metrics/SessionTracker";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "apiKey": apiKey !== undefined && apiKey !== null ? "" + apiKey : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessionStatsUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessionStatsUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetSessionStatsUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get all child apps
     * @param authorization ABT token
     * @param clientId (optional) clientId
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @return OK
     */
    getAllChildApplicationsUsingGET(authorization: string, clientId?: string | null | undefined, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Oauth/Applications?";
        if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&"; 
        if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&"; 
        if (sortDir !== undefined)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllChildApplicationsUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllChildApplicationsUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllChildApplicationsUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Create a child app and associate to a parent app
     * @param authorization ABT and JWT ABT tokens
     * @param appTO application
     * @return OK
     */
    createChildApplicationUsingPOST(authorization: string, appTO: ChildAppTO): Observable<any> {
        let url_ = this.baseUrl + "/Oauth/Applications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateChildApplicationUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChildApplicationUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processCreateChildApplicationUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Conflict. Child App already exists.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get child app byId
     * @param authorization ABT token
     * @param clientId Client Id.
     * @return OK
     */
    getChildApplicationUsingGET(authorization: string, clientId: string): Observable<any> {
        let url_ = this.baseUrl + "/Oauth/Applications/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChildApplicationUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChildApplicationUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetChildApplicationUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Update a child app
     * @param authorization ABT token
     * @param appTO application
     * @param clientId clientId
     * @return OK
     */
    updateChildApplicationUsingPUT(authorization: string, appTO: ChildAppTO, clientId: string): Observable<any> {
        let url_ = this.baseUrl + "/Oauth/Applications/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateChildApplicationUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateChildApplicationUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateChildApplicationUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad Request. Child App does not exists.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Delete child app byId
     * @param authorization ABT token
     * @param clientId Client Id.
     * @return OK
     */
    removeChildApplicationUsingDELETE(authorization: string, clientId: string): Observable<any> {
        let url_ = this.baseUrl + "/Oauth/Applications/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveChildApplicationUsingDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveChildApplicationUsingDELETE(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveChildApplicationUsingDELETE(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = resultData204 !== undefined ? resultData204 : <any>null;
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Application not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unexpected error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Rotate Secret Key
     * @param authorization ABT token
     * @param clientId clientId
     * @return OK
     */
    rotateUsingPUT(authorization: string, clientId: string): Observable<any> {
        let url_ = this.baseUrl + "/Oauth/Applications/{clientId}/RotateSecretKey";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRotateUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRotateUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processRotateUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get group/role user stats
     * @param authorization ABT and JWT ABT tokens
     * @param roleId (optional) roleId --> for strategy roles
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    getStatsUsingGET(authorization: string, roleId?: string | null | undefined, strategy?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/OrganizationUtil/Stats?";
        if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&"; 
        if (strategy !== undefined)
            url_ += "strategy=" + encodeURIComponent("" + strategy) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatsUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatsUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetStatsUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Save an organization
     * @param authorization UBT token
     * @param organization organization
     * @param landingPageUrl (optional) landingPageUrl
     * @return OK
     */
    saveUsingPOST(authorization: string, organization: OrganizationTO, landingPageUrl?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/?";
        if (landingPageUrl !== undefined)
            url_ += "landingPageUrl=" + encodeURIComponent("" + landingPageUrl) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processSaveUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Validation failed: Organization name, description, founder & applicationId  cannot be empty", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 406) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Cannot create organization with the name: Default. Since its reserved.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Duplicate Organization name", status, _responseText, _headers);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid domain", status, _responseText, _headers);
            }));
        } else if (status === 429) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Too many organizations create requests. Only limited organizations can be created an user.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Updates an organization
     * @param authorization UBT token
     * @param organization organization
     * @return Organization updated
     */
    updateUsingPUT(authorization: string, organization: OrganizationTO): Observable<OrganizationTO> {
        let url_ = this.baseUrl + "/Organizations/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationTO>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUsingPUT(response: HttpResponseBase): Observable<OrganizationTO> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("ApplicationId mismatch", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 406) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Cannot create organization with the name: Default. Since its reserved.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Duplicate Organization name", status, _responseText, _headers);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid domain", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationTO>(<any>null);
    }

    /**
     * Get workgroup admins
     * @param authorization UBT and JWT UBT tokens
     * @param orgId OrgId
     * @return Ok
     */
    getWorkGroupAdmins(authorization: string, orgId: string): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{OrgId}/Admin/Users";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{OrgId}", encodeURIComponent("" + orgId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkGroupAdmins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkGroupAdmins(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkGroupAdmins(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Assign Workgroup admin role
     * @param authorization JWT UBT token
     * @param orgId OrgId
     * @param emailIds emailIds
     * @param collaborationDomain (optional) collaborationDomain
     * @param collaboratorType (optional) collaboratorType
     * @return Updated
     */
    addWorkGroupAdmin(authorization: string, orgId: string, emailIds: string[], collaborationDomain?: string | null | undefined, collaboratorType?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{OrgId}/Admin/Users?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{OrgId}", encodeURIComponent("" + orgId)); 
        if (collaborationDomain !== undefined)
            url_ += "collaborationDomain=" + encodeURIComponent("" + collaborationDomain) + "&"; 
        if (collaboratorType !== undefined)
            url_ += "collaboratorType=" + encodeURIComponent("" + collaboratorType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWorkGroupAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWorkGroupAdmin(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processAddWorkGroupAdmin(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Revoke Role workgroup admin role
     * @param authorization JWT UBT token
     * @param orgId OrgId
     * @param emailIds emailIds
     * @param collaborationDomain (optional) collaborationDomain
     * @param collaboratorType (optional) collaboratorType
     * @return OK
     */
    removeWorkGroupAdmin(authorization: string, orgId: string, emailIds: string[], collaborationDomain?: string | null | undefined, collaboratorType?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{OrgId}/Admin/Users?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{OrgId}", encodeURIComponent("" + orgId)); 
        if (collaborationDomain !== undefined)
            url_ += "collaborationDomain=" + encodeURIComponent("" + collaborationDomain) + "&"; 
        if (collaboratorType !== undefined)
            url_ += "collaboratorType=" + encodeURIComponent("" + collaboratorType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveWorkGroupAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveWorkGroupAdmin(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveWorkGroupAdmin(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = resultData204 !== undefined ? resultData204 : <any>null;
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Assign role
     * @param authorization JWT UBT token
     * @param orgId OrgId
     * @param emailIds emailIds
     * @param id id
     * @param collaborationDomain (optional) collaborationDomain
     * @param collaboratorType (optional) collaboratorType
     * @return Updated
     */
    addUserRole(authorization: string, orgId: string, emailIds: string[], id: string, collaborationDomain?: string | null | undefined, collaboratorType?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{OrgId}/Roles/{id}/Users?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{OrgId}", encodeURIComponent("" + orgId)); 
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (collaborationDomain !== undefined)
            url_ += "collaborationDomain=" + encodeURIComponent("" + collaborationDomain) + "&"; 
        if (collaboratorType !== undefined)
            url_ += "collaboratorType=" + encodeURIComponent("" + collaboratorType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserRole(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processAddUserRole(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Remove Role
     * @param authorization JWT UBT token
     * @param orgId OrgId
     * @param emailIds emailIds
     * @param id id
     * @param collaborationDomain (optional) collaborationDomain
     * @param collaboratorType (optional) collaboratorType
     * @return OK
     */
    removeUserRole(authorization: string, orgId: string, emailIds: string[], id: string, collaborationDomain?: string | null | undefined, collaboratorType?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{OrgId}/Roles/{id}/Users?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{OrgId}", encodeURIComponent("" + orgId)); 
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (collaborationDomain !== undefined)
            url_ += "collaborationDomain=" + encodeURIComponent("" + collaborationDomain) + "&"; 
        if (collaboratorType !== undefined)
            url_ += "collaboratorType=" + encodeURIComponent("" + collaboratorType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserRole(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUserRole(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = resultData204 !== undefined ? resultData204 : <any>null;
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get user details for a user within the org
     * @param authorization UBT and JWT UBT tokens
     * @param orgId OrgId
     * @param pGuid pGuid
     * @return List of users
     */
    getUserDetails(authorization: string, orgId: string, pGuid: string): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{OrgId}/Users/{pGuid}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{OrgId}", encodeURIComponent("" + orgId)); 
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDetails(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserDetails(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get User Roles
     * @param authorization UBT and JWT UBT tokens
     * @param orgId OrgId
     * @param pGuid pGuid
     * @return List of Roles
     */
    getUserRoles(authorization: string, orgId: string, pGuid: string): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{OrgId}/Users/{pGuid}/Roles/";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{OrgId}", encodeURIComponent("" + orgId)); 
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Gets invited users list
     * @param authorization UBT token
     * @param id id
     * @param invitationStatus (optional) invitationStatus
     * @param limit (optional) Page Size
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    getInvitedUsersUsingGET(authorization: string, id: string, invitationStatus?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined, strategy?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{id}/Invites/?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (invitationStatus !== undefined)
            url_ += "invitationStatus=" + encodeURIComponent("" + invitationStatus) + "&"; 
        if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&"; 
        if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&"; 
        if (sortDir !== undefined)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&"; 
        if (strategy !== undefined)
            url_ += "strategy=" + encodeURIComponent("" + strategy) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvitedUsersUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvitedUsersUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvitedUsersUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get Roles registered by all applications
     * @param authorization UBT (Domain admin or workgroup admin)
     * @param id id
     * @param domain (optional) domain
     * @return List of Roles
     */
    getAppRolesForOrg(authorization: string, id: string, domain?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{id}/Roles/?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (domain !== undefined)
            url_ += "domain=" + encodeURIComponent("" + domain) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppRolesForOrg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppRolesForOrg(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppRolesForOrg(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * DELETE users from workgroup
     * @param authorization JWT UBT token
     * @param emailIds emailIds
     * @param id id
     * @param isRemoveWorkGroupAdministrator (optional) true/false Default: false
     * @return OK
     */
    removeUsersInOrgUsingDELETE(authorization: string, emailIds: string[], id: string, isRemoveWorkGroupAdministrator?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{id}/Users?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (isRemoveWorkGroupAdministrator !== undefined)
            url_ += "isRemoveWorkGroupAdministrator=" + encodeURIComponent("" + isRemoveWorkGroupAdministrator) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUsersInOrgUsingDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUsersInOrgUsingDELETE(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUsersInOrgUsingDELETE(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get users list within the organization
     * @param authorization ABT, UBT token
     * @param id id
     * @param firstname (optional) firstname
     * @param lastname (optional) lastname
     * @param limit (optional) Page Size
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @param username (optional) username
     * @return OK
     */
    getUsersUsingGET(authorization: string, id: string, firstname?: string | null | undefined, lastname?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined, strategy?: string | null | undefined, username?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{id}/Users/?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (firstname !== undefined)
            url_ += "firstname=" + encodeURIComponent("" + firstname) + "&"; 
        if (lastname !== undefined)
            url_ += "lastname=" + encodeURIComponent("" + lastname) + "&"; 
        if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&"; 
        if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&"; 
        if (sortDir !== undefined)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&"; 
        if (strategy !== undefined)
            url_ += "strategy=" + encodeURIComponent("" + strategy) + "&"; 
        if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get Permissions
     * @param authorization ABT, JWT ABT tokens
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @return OK
     */
    getAllPermissionsUsingGET(authorization: string, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Permission/?";
        if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&"; 
        if (sortDir !== undefined)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissionsUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissionsUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissionsUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Register/Create a role for an app: Required field: name
     * @param authorization JWT ABT token
     * @param roleTO roleTO
     * @return OK
     */
    saveRole(authorization: string, roleTO: RoleTO): Observable<any> {
        let url_ = this.baseUrl + "/Roles/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRole(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processSaveRole(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Already exists", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get Roles registered by all applications
     * @param authorization ABT and JWT ABT tokens
     * @param domain (optional) domain
     * @return List of Roles
     */
    getApplicationRoles(authorization: string, domain?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Roles/Applications/?";
        if (domain !== undefined)
            url_ += "domain=" + encodeURIComponent("" + domain) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationRoles(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetApplicationRoles(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get Roles defined for an Application
     * @param authorization JWT ABT token
     * @param id id
     * @return List of Roles
     */
    getRoles(authorization: string, id: string): Observable<any> {
        let url_ = this.baseUrl + "/Roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Update role for an app
     * @param authorization JWT ABT token
     * @param id id
     * @param roleTO roleTO
     * @return Updated
     */
    updateRole(authorization: string, id: string, roleTO: RoleTO): Observable<any> {
        let url_ = this.baseUrl + "/Roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRole(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRole(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Delete Role for a given Application
     * @param authorization JWT ABT token
     * @param id id
     * @return deleted
     */
    deleteRole(authorization: string, id: string): Observable<any> {
        let url_ = this.baseUrl + "/Roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Scope Lookup service
     * @param clientId (optional) clientId
     * @param name (optional) name
     * @param namespace (optional) namespace
     * @return OK
     */
    lookupService(clientId?: string | null | undefined, name?: string | null | undefined, namespace?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Scopes/?";
        if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (namespace !== undefined)
            url_ += "namespace=" + encodeURIComponent("" + namespace) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupService(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processLookupService(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Add scope to an app
     * @param authorization ABT Token
     * @param scopeRegistryTO scopeRegistryTO
     * @return OK
     */
    addScopeForApp(authorization: string, scopeRegistryTO: ScopeRegistryTO): Observable<any> {
        let url_ = this.baseUrl + "/Scopes/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scopeRegistryTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddScopeForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddScopeForApp(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processAddScopeForApp(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Delete scope
     * @param authorization ABT Token
     * @param id id
     * @return OK
     */
    deleteScope(authorization: string, id: number): Observable<any> {
        let url_ = this.baseUrl + "/Scopes/{id}/";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteScope(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteScope(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteScope(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = resultData204 !== undefined ? resultData204 : <any>null;
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Login: Perform authentication (Grant type: Password by default)
     * @param authorization Basic Base64ENCODED(username:password)
     * @param grant_type grant_type
     * @param requestObject requestObject
     * @return OK
     */
    authenticateUsingPOST(authorization: string, grant_type: string, requestObject: any): Observable<any> {
        let url_ = this.baseUrl + "/Session/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestObject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "grant_type": grant_type !== undefined && grant_type !== null ? "" + grant_type : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Update workgroupId for the session (user must be part of workgroup)
     * @param authorization UBT token
     * @param requestObject requestObject
     * @return OK
     */
    updateOrgIdUsingPUT(authorization: string, requestObject: { [key: string]: string; }): Observable<any> {
        let url_ = this.baseUrl + "/Session/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestObject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrgIdUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrgIdUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateOrgIdUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Invalidate Token
     * @param access_token access_token
     * @param clientId (optional) clientId
     * @return OK
     */
    invalidateTokenUsingDELETE(access_token: string, clientId?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Session/InvalidateToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "access_token": access_token !== undefined && access_token !== null ? "" + access_token : "", 
                "clientId": clientId !== undefined && clientId !== null ? "" + clientId : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvalidateTokenUsingDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvalidateTokenUsingDELETE(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processInvalidateTokenUsingDELETE(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get sessionGuid
     * @param authorization ABT, UBT, ABT JWT, JWT UBT, PGA UBT tokens
     * @param pSessionGuid pSessionGuid
     * @return OK
     */
    getProxySessionUsingGET(authorization: string, pSessionGuid: string): Observable<any> {
        let url_ = this.baseUrl + "/Session/ProxySession/{pSessionGuid}";
        if (pSessionGuid === undefined || pSessionGuid === null)
            throw new Error("The parameter 'pSessionGuid' must be defined.");
        url_ = url_.replace("{pSessionGuid}", encodeURIComponent("" + pSessionGuid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProxySessionUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProxySessionUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetProxySessionUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get JWT token for ABT or UBT access_token or psToken issued by platform
     * @param authorization ABT, UBT, JWT ABT, JWT UBT, PGA UBT tokens
     * @param access_token access_token
     * @param audience audience
     * @return OK
     */
    getTokenUsingGET(authorization: string, access_token: string, audience: string): Observable<any> {
        let url_ = this.baseUrl + "/Session/ProxyToken?";
        if (audience === undefined || audience === null)
            throw new Error("The parameter 'audience' must be defined and cannot be null.");
        else
            url_ += "audience=" + encodeURIComponent("" + audience) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "access_token": access_token !== undefined && access_token !== null ? "" + access_token : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetTokenUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Terminate user's own tokens
     * @param authorization UBT token
     * @param access_token access_token
     * @return OK
     */
    terminateUsingDELETE(authorization: string, access_token: string): Observable<any> {
        let url_ = this.baseUrl + "/Session/Terminate/{access_token}";
        if (access_token === undefined || access_token === null)
            throw new Error("The parameter 'access_token' must be defined.");
        url_ = url_.replace("{access_token}", encodeURIComponent("" + access_token)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminateUsingDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminateUsingDELETE(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processTerminateUsingDELETE(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get the session details for the access_token
     * @param access_token access_token
     * @param clientId (optional) clientId
     * @param domain (optional) domain
     * @return OK
     */
    validateRawTokenUsingPOST(access_token: string, clientId?: string | null | undefined, domain?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Session/ValidateToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "access_token": access_token !== undefined && access_token !== null ? "" + access_token : "", 
                "clientId": clientId !== undefined && clientId !== null ? "" + clientId : "", 
                "domain": domain !== undefined && domain !== null ? "" + domain : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateRawTokenUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateRawTokenUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processValidateRawTokenUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get the session details for the access_token
     * @param authorization Basic BASE64ENCODED(clientId:clientSecret)
     * @param access_token access_token
     * @param domain (optional) domain
     * @return OK
     */
    validateTokenUsingGET(authorization: string, access_token: string, domain?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Session/{access_token}";
        if (access_token === undefined || access_token === null)
            throw new Error("The parameter 'access_token' must be defined.");
        url_ = url_.replace("{access_token}", encodeURIComponent("" + access_token)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "domain": domain !== undefined && domain !== null ? "" + domain : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateTokenUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateTokenUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processValidateTokenUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Track User session
     * @param authorization UBT token
     * @param clientId clientId
     * @param lastAccessSync (optional) Time elapsed (in seconds) since last user activity
     * @return OK
     */
    trackSessionUsingPUT(authorization: string, clientId: string, lastAccessSync?: number | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/SessionTracker/?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&"; 
        if (lastAccessSync !== undefined)
            url_ += "lastAccessSync=" + encodeURIComponent("" + lastAccessSync) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrackSessionUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrackSessionUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processTrackSessionUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Check idle timeout
     * @param authorization UBT and JWT UBT tokens
     * @return OK
     */
    isIdleUsingGET(authorization: string): Observable<any> {
        let url_ = this.baseUrl + "/SessionTracker/IsIdle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsIdleUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsIdleUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processIsIdleUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Check Health
     * @return OK
     */
    health(): Observable<any> {
        let url_ = this.baseUrl + "/SessionTracker/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get jwtv2 token
     * @param grant_type grant_type
     * @param authorization (optional) Basic BASE64ENCODED(clientId:clientSecret) or Basic BASE64ENCODED(clientId:userApiKey)
     * @param assertion (optional) assertion
     * @param audience (optional) audience
     * @param data (optional) data
     * @param refresh_token (optional) refresh_token
     * @param scope (optional) scope
     * @return OK
     */
    getJWTTokenUsingPOST(grant_type: string, authorization?: string | null | undefined, assertion?: string | null | undefined, audience?: string | null | undefined, data?: any | null | undefined, refresh_token?: string | null | undefined, scope?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Token?";
        if (grant_type === undefined || grant_type === null)
            throw new Error("The parameter 'grant_type' must be defined and cannot be null.");
        else
            url_ += "grant_type=" + encodeURIComponent("" + grant_type) + "&"; 
        if (assertion !== undefined)
            url_ += "assertion=" + encodeURIComponent("" + assertion) + "&"; 
        if (audience !== undefined)
            url_ += "audience=" + encodeURIComponent("" + audience) + "&"; 
        if (refresh_token !== undefined)
            url_ += "refresh_token=" + encodeURIComponent("" + refresh_token) + "&"; 
        if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJWTTokenUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJWTTokenUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetJWTTokenUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        }  else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Terminate JWT Token
     * @param authorization Basic BASE64ENCODED(clientId:clientSecret) or PGA tokens
     * @param access_token access_token
     * @return OK
     */
    deleteUsingDELETE(authorization: string, access_token: string): Observable<any> {
        let url_ = this.baseUrl + "/Token?";
        if (access_token === undefined || access_token === null)
            throw new Error("The parameter 'access_token' must be defined and cannot be null.");
        else
            url_ += "access_token=" + encodeURIComponent("" + access_token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUsingDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUsingDELETE(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUsingDELETE(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Generate assertion token
     * @param authorization UBT token
     * @param issuer issuer
     * @param audience (optional) audience
     * @param mem (optional) mem
     * @return OK
     */
    generateAssertion(authorization: string, issuer: string, audience?: string | null | undefined, mem?: string[] | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Token/Assertion?";
        if (issuer === undefined || issuer === null)
            throw new Error("The parameter 'issuer' must be defined and cannot be null.");
        else
            url_ += "issuer=" + encodeURIComponent("" + issuer) + "&"; 
        if (audience !== undefined)
            url_ += "audience=" + encodeURIComponent("" + audience) + "&"; 
        if (mem !== undefined)
            mem && mem.forEach(item => { url_ += "mem=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAssertion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAssertion(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateAssertion(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Generate impersonated assertion token with application credentials.
     * @param authorization Basic BASE64ENCODED(clientId:clientSecret)
     * @param acl (optional) acl
     * @param cwid (optional) cwid
     * @param mem (optional) mem
     * @param membershipType (optional) membershipType
     * @param tsd (optional) TrustedClaims
     * @param uid (optional) uid
     * @return OK
     */
    generateClientImpersonationAssertionUsingPOST(authorization: string, acl?: string[] | null | undefined, cwid?: string | null | undefined, mem?: string[] | null | undefined, membershipType?: MembershipType | null | undefined, tsd?: any | null | undefined, uid?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Token/Impersonation/Assertion?";
        if (acl !== undefined)
            acl && acl.forEach(item => { url_ += "acl=" + encodeURIComponent("" + item) + "&"; });
        if (cwid !== undefined)
            url_ += "cwid=" + encodeURIComponent("" + cwid) + "&"; 
        if (mem !== undefined)
            mem && mem.forEach(item => { url_ += "mem=" + encodeURIComponent("" + item) + "&"; });
        if (membershipType !== undefined)
            url_ += "membershipType=" + encodeURIComponent("" + membershipType) + "&"; 
        if (uid !== undefined)
            url_ += "uid=" + encodeURIComponent("" + uid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tsd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateClientImpersonationAssertionUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateClientImpersonationAssertionUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateClientImpersonationAssertionUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Register a new user for the domain
     * @param authorization ABT and PGA UBT tokens
     * @param activationLink activationLink
     * @param user user
     * @param skipEmail (optional) skipEmail
     * @return OK
     */
    createUsingPOST(authorization: string, activationLink: string, user: UserTO, skipEmail?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Users/?";
        if (skipEmail !== undefined)
            url_ += "skipEmail=" + encodeURIComponent("" + skipEmail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "activationLink": activationLink !== undefined && activationLink !== null ? "" + activationLink : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processCreateUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get User Activity
     * @param authorization UBT token
     * @return OK
     */
    getUserActivityUsingGET(authorization: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/Activity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserActivityUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * GET ApiKeys for the user
     * @param authorization UBT token
     * @return OK
     */
    getAllUsingGET(authorization: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/ApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Save ApiKey for the user
     * @param authorization UBT token
     * @param userAPIKeyMapTO userAPIKeyMapTO
     * @return OK
     */
    saveV2UsingPOST(authorization: string, userAPIKeyMapTO: UserAPIKeyMapTO): Observable<any> {
        let url_ = this.baseUrl + "/Users/ApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userAPIKeyMapTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveV2UsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveV2UsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processSaveV2UsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Entity", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Save ApiKey for the user
     * @param authorization UBT token
     * @return OK
     */
    saveUsingPUT(authorization: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/ApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processSaveUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * DELETE All ApiKeys
     * @param authorization UBT token
     * @return OK
     */
    deleteAllUsingDELETE(authorization: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/ApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUsingDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUsingDELETE(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAllUsingDELETE(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * ApiKeyMigration
     * @param authorization PGA token
     * @return OK
     */
    migrateUsingPOST(authorization: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/ApiKey/Migrate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrateUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processMigrateUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get organizations for list of users with ABT token
     * @param authorization ABT token
     * @param pGuids pGuids
     * @return OK
     */
    getAllUserOrgsDomainsUsingPOST(authorization: string, pGuids: string[]): Observable<any> {
        let url_ = this.baseUrl + "/Users/Search/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pGuids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserOrgsDomainsUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserOrgsDomainsUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserOrgsDomainsUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get long-running and active user session with UBT
     * @param authorization UBT and PGA UBT tokens
     * @return OK
     */
    getUserSessionsUsingGET(authorization: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/Session";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSessionsUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSessionsUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserSessionsUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * ${User.getLastOrgId.APIOperation}
     * @param authorization ${User.getLastOrgId.Authorization}
     * @return OK
     */
    getLastOrgIdUsingGET(authorization: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/Workgroup/Log";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastOrgIdUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastOrgIdUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetLastOrgIdUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * resendConfirmation
     * @param requestObject requestObject
     * @return OK
     */
    resendConfirmationUsingPOST(requestObject: any): Observable<any> {
        let url_ = this.baseUrl + "/Users/resend/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestObject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendConfirmationUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendConfirmationUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processResendConfirmationUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Activates the user
     * @param authorization ABT token
     * @param defaultHomePageUrl defaultHomePageUrl
     * @param domain domain
     * @param key key
     * @return OK
     */
    verifyEmailAddressUsingPOST(authorization: string, defaultHomePageUrl: string, domain: string, key: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/verifyEmailAddress?";
        if (defaultHomePageUrl === undefined || defaultHomePageUrl === null)
            throw new Error("The parameter 'defaultHomePageUrl' must be defined and cannot be null.");
        else
            url_ += "defaultHomePageUrl=" + encodeURIComponent("" + defaultHomePageUrl) + "&"; 
        if (domain === undefined || domain === null)
            throw new Error("The parameter 'domain' must be defined and cannot be null.");
        else
            url_ += "domain=" + encodeURIComponent("" + domain) + "&"; 
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyEmailAddressUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyEmailAddressUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyEmailAddressUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Disable the user
     * @param authorization ABT token
     * @param pGuid pGuid
     * @return OK
     */
    disableUserUsingDELETE(authorization: string, pGuid: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/{pGuid}";
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableUserUsingDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableUserUsingDELETE(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processDisableUserUsingDELETE(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get organizations with ABT token
     * @param authorization ABT and JWT ABT tokens
     * @param pGuid pGuid
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    getOrganizationsWithABTUsingGET(authorization: string, pGuid: string, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined, strategy?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Users/{pGuid}/IOrgs/?";
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&"; 
        if (sortDir !== undefined)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&"; 
        if (strategy !== undefined)
            url_ += "strategy=" + encodeURIComponent("" + strategy) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationsWithABTUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationsWithABTUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationsWithABTUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Gets organizations with roles
     * @param authorization ABT, UBT, JWT UBT, JWT ABT and PGA UBT tokens
     * @param pGuid pGuid
     * @return OK
     */
    getOrganizationRolesUsingGET(authorization: string, pGuid: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/{pGuid}/OrgRoles/";
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationRolesUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationRolesUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationRolesUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Adds a permission to a user
     * @param authorization Authorization
     * @param id id
     * @param pGuid pGuid
     * @return OK
     */
    addPermissionUsingPUT(authorization: string, id: string, pGuid: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/{pGuid}/Permission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPermissionUsingPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPermissionUsingPUT(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processAddPermissionUsingPUT(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
       
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Removes a permission for a user
     * @param authorization Authorization
     * @param id id
     * @param pGuid pGuid
     * @return OK
     */
    removePermissionUsingDELETE(authorization: string, id: string, pGuid: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/{pGuid}/Permission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePermissionUsingDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePermissionUsingDELETE(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processRemovePermissionUsingDELETE(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get User Permissions
     * @param authorization ABT token
     * @param pGuid pGuid
     * @param clientId (optional) clientId
     * @return OK
     */
    getAllUserPermissionsUsingGET(authorization: string, pGuid: string, clientId?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Users/{pGuid}/Roles?";
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserPermissionsUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserPermissionsUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserPermissionsUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get long-running and active user session for given pGuid
     * @param authorization UBT and PGA UBT tokens
     * @param pGuid pGuid
     * @return OK
     */
    getUserSessionBypGuidUsingGET(authorization: string, pGuid: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/{pGuid}/Session";
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSessionBypGuidUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSessionBypGuidUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserSessionBypGuidUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * health
     * @return OK
     */
    healthUsingGET(): Observable<any> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealthUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealthUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processHealthUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Generate assertion token
     * @param authorization (optional) UBT token
     * @param x_API_Key (optional) Base 64 encoded clientID:APIKey
     * @param acl (optional) acl
     * @param audience (optional) audience
     * @param cwid (optional) cwid
     * @param issuer (optional) issuer
     * @param mem (optional) mem
     * @return OK
     */
    generateAssertionUsingPOST(authorization?: string | null | undefined, x_API_Key?: string | null | undefined, acl?: string[] | null | undefined, audience?: string | null | undefined, cwid?: string | null | undefined, issuer?: string | null | undefined, mem?: string[] | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/v2/Token/Assertion?";
        if (acl !== undefined)
            acl && acl.forEach(item => { url_ += "acl=" + encodeURIComponent("" + item) + "&"; });
        if (audience !== undefined)
            url_ += "audience=" + encodeURIComponent("" + audience) + "&"; 
        if (cwid !== undefined)
            url_ += "cwid=" + encodeURIComponent("" + cwid) + "&"; 
        if (issuer !== undefined)
            url_ += "issuer=" + encodeURIComponent("" + issuer) + "&"; 
        if (mem !== undefined)
            mem && mem.forEach(item => { url_ += "mem=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "X-API-Key": x_API_Key !== undefined && x_API_Key !== null ? "" + x_API_Key : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAssertionUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAssertionUsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateAssertionUsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Generate assertion token
     * @param authorization Basic BASE64ENCODED(clientId:clientSecret)
     * @param tsd TrustedClaims
     * @param x_API_Key (optional) Base 64 encoded clientID:APIKey
     * @param acl (optional) acl
     * @param audience (optional) audience
     * @param cwid (optional) cwid
     * @param mem (optional) mem
     * @param membershipType (optional) membershipType
     * @param psToken (optional) psToken
     * @return OK
     */
    generateAssertionV3UsingPOST(authorization: string, tsd: any, x_API_Key?: string | null | undefined, acl?: string[] | null | undefined, audience?: string | null | undefined, cwid?: string | null | undefined, mem?: string[] | null | undefined, membershipType?: MembershipType2 | null | undefined, psToken?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/v3/Token/Assertion?";
        if (acl !== undefined)
            acl && acl.forEach(item => { url_ += "acl=" + encodeURIComponent("" + item) + "&"; });
        if (audience !== undefined)
            url_ += "audience=" + encodeURIComponent("" + audience) + "&"; 
        if (cwid !== undefined)
            url_ += "cwid=" + encodeURIComponent("" + cwid) + "&"; 
        if (mem !== undefined)
            mem && mem.forEach(item => { url_ += "mem=" + encodeURIComponent("" + item) + "&"; });
        if (membershipType !== undefined)
            url_ += "membershipType=" + encodeURIComponent("" + membershipType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tsd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "X-API-Key": x_API_Key !== undefined && x_API_Key !== null ? "" + x_API_Key : "", 
                "psToken": psToken !== undefined && psToken !== null ? "" + psToken : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAssertionV3UsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAssertionV3UsingPOST(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateAssertionV3UsingPOST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * version
     * @return OK
     */
    versionUsingGET(): Observable<any> {
        let url_ = this.baseUrl + "/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVersionUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVersionUsingGET(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processVersionUsingGET(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IImpersonationUsingPOSTPlatformClient {
    /**
     * Creates impersonation session.
     * @param authorization ABT token
     * @param requestObject requestObject
     * @return OK
     */
    1(authorization: string, requestObject: any): Observable<any>;
}

@Injectable()
export class ImpersonationUsingPOSTPlatformClient implements IImpersonationUsingPOSTPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Creates impersonation session.
     * @param authorization ABT token
     * @param requestObject requestObject
     * @return OK
     */
    1(authorization: string, requestObject: any): Observable<any> {
        let url_ = this.baseUrl + "/Impersonation/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestObject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 429) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IGetUsingGETPlatformClient {
    /**
     * Get Organization by id
     * @param authorization ABT and JWT ABT tokens
     * @param id id
     * @return OK
     */
    1(authorization: string, id: string): Observable<OrganizationTO>;
    /**
     * Get Organization by id
     * @param authorization UBT and JWT UBT tokens
     * @param id id
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    2(authorization: string, id: string, strategy?: string | null | undefined): Observable<any>;
    /**
     * Get a permission
     * @param authorization JWT ABT token
     * @param id id
     * @return OK
     */
    3(authorization: string, id: string): Observable<any>;
    /**
     * GET roles associated to ApiKey
     * @param authorization UBT token
     * @param keyId KeyId
     * @return OK
     */
    4(authorization: string, keyId: string): Observable<any>;
    /**
     * Get user details for pGuid
     * @param authorization ABT, UBT token of Domain Admin
     * @param pGuid pGuid
     * @return OK
     */
    5(authorization: string, pGuid: string): Observable<any>;
}

@Injectable()
export class GetUsingGETPlatformClient implements IGetUsingGETPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Get Organization by id
     * @param authorization ABT and JWT ABT tokens
     * @param id id
     * @return OK
     */
    1(authorization: string, id: string): Observable<OrganizationTO> {
        let url_ = this.baseUrl + "/OrganizationUtil/Organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationTO>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<OrganizationTO> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationTO>(<any>null);
    }

    /**
     * Get Organization by id
     * @param authorization UBT and JWT UBT tokens
     * @param id id
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    2(authorization: string, id: string, strategy?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (strategy !== undefined)
            url_ += "strategy=" + encodeURIComponent("" + strategy) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process2(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process2(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get a permission
     * @param authorization JWT ABT token
     * @param id id
     * @return OK
     */
    3(authorization: string, id: string): Observable<any> {
        let url_ = this.baseUrl + "/Permission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process3(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process3(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * GET roles associated to ApiKey
     * @param authorization UBT token
     * @param keyId KeyId
     * @return OK
     */
    4(authorization: string, keyId: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/ApiKey/{KeyId}";
        if (keyId === undefined || keyId === null)
            throw new Error("The parameter 'keyId' must be defined.");
        url_ = url_.replace("{KeyId}", encodeURIComponent("" + keyId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process4(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process4(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Get user details for pGuid
     * @param authorization ABT, UBT token of Domain Admin
     * @param pGuid pGuid
     * @return OK
     */
    5(authorization: string, pGuid: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/{pGuid}";
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process5(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process5(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IGetOrganizationsUsingGETPlatformClient {
    /**
     * Gets organization list
     * @param authorization UBT token
     * @param isAdmin (optional) isAdmin - only applicable for roles strategy
     * @param isOwner (optional) isOwner - only applicable for roles strategy
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param searchType (optional) searchType
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    1(authorization: string, isAdmin?: boolean | null | undefined, isOwner?: boolean | null | undefined, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, searchType?: string | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined, strategy?: string | null | undefined): Observable<any>;
    /**
     * Gets organizations
     * @param authorization ABT, UBT, JWT UBT, JWT ABT and PGA UBT tokens
     * @param pGuid pGuid
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    2(authorization: string, pGuid: string, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined, strategy?: string | null | undefined): Observable<any>;
}

@Injectable()
export class GetOrganizationsUsingGETPlatformClient implements IGetOrganizationsUsingGETPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Gets organization list
     * @param authorization UBT token
     * @param isAdmin (optional) isAdmin - only applicable for roles strategy
     * @param isOwner (optional) isOwner - only applicable for roles strategy
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param searchType (optional) searchType
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    1(authorization: string, isAdmin?: boolean | null | undefined, isOwner?: boolean | null | undefined, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, searchType?: string | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined, strategy?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/?";
        if (isAdmin !== undefined)
            url_ += "isAdmin=" + encodeURIComponent("" + isAdmin) + "&"; 
        if (isOwner !== undefined)
            url_ += "isOwner=" + encodeURIComponent("" + isOwner) + "&"; 
        if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (searchType !== undefined)
            url_ += "searchType=" + encodeURIComponent("" + searchType) + "&"; 
        if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&"; 
        if (sortDir !== undefined)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&"; 
        if (strategy !== undefined)
            url_ += "strategy=" + encodeURIComponent("" + strategy) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Gets organizations
     * @param authorization ABT, UBT, JWT UBT, JWT ABT and PGA UBT tokens
     * @param pGuid pGuid
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @param strategy (optional) strategy ( roles or groups ). By default groups
     * @return OK
     */
    2(authorization: string, pGuid: string, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined, strategy?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Users/{pGuid}/Organizations/?";
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&"; 
        if (sortDir !== undefined)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&"; 
        if (strategy !== undefined)
            url_ += "strategy=" + encodeURIComponent("" + strategy) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process2(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process2(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IAddUserRolePlatformClient {
    /**
     * Assign roles to Users
     * @param authorization JWT UBT token
     * @param orgId OrgId
     * @param userRoleMap userRoleMap
     * @param collaborationDomain (optional) collaborationDomain
     * @param collaboratorType (optional) collaboratorType
     * @return Updated
     */
    1(authorization: string, orgId: string, userRoleMap: UserRoleMapTO[], collaborationDomain?: string | null | undefined, collaboratorType?: string | null | undefined): Observable<any>;
}

@Injectable()
export class AddUserRolePlatformClient implements IAddUserRolePlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Assign roles to Users
     * @param authorization JWT UBT token
     * @param orgId OrgId
     * @param userRoleMap userRoleMap
     * @param collaborationDomain (optional) collaborationDomain
     * @param collaboratorType (optional) collaboratorType
     * @return Updated
     */
    1(authorization: string, orgId: string, userRoleMap: UserRoleMapTO[], collaborationDomain?: string | null | undefined, collaboratorType?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{OrgId}/UsersRoles?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{OrgId}", encodeURIComponent("" + orgId)); 
        if (collaborationDomain !== undefined)
            url_ += "collaborationDomain=" + encodeURIComponent("" + collaborationDomain) + "&"; 
        if (collaboratorType !== undefined)
            url_ += "collaboratorType=" + encodeURIComponent("" + collaboratorType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userRoleMap);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IDeleteUsingDELETEPlatformClient {
    /**
     * DELETE Organization
     * @param authorization UBT token
     * @param id id
     * @return OK
     */
    2(authorization: string, id: string): Observable<any>;
    /**
     * Delete a Permission
     * @param authorization JWT ABT token
     * @param id id
     * @return OK
     */
    3(authorization: string, id: string): Observable<any>;
    /**
     * Invalidate Token
     * @param authorization Basic BASE64ENCODED(clientId:clientSecret)
     * @param access_token access_token
     * @return OK
     */
    1(authorization: string, access_token: string): Observable<any>;
    /**
     * DELETE ApiKey
     * @param authorization UBT token
     * @param keyId KeyId
     * @return OK
     */
    4(authorization: string, keyId: string): Observable<any>;
}

@Injectable()
export class DeleteUsingDELETEPlatformClient implements IDeleteUsingDELETEPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * DELETE Organization
     * @param authorization UBT token
     * @param id id
     * @return OK
     */
    2(authorization: string, id: string): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process2(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process2(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Delete a Permission
     * @param authorization JWT ABT token
     * @param id id
     * @return OK
     */
    3(authorization: string, id: string): Observable<any> {
        let url_ = this.baseUrl + "/Permission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process3(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process3(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Invalidate Token
     * @param authorization Basic BASE64ENCODED(clientId:clientSecret)
     * @param access_token access_token
     * @return OK
     */
    1(authorization: string, access_token: string): Observable<any> {
        let url_ = this.baseUrl + "/Session/{access_token}";
        if (access_token === undefined || access_token === null)
            throw new Error("The parameter 'access_token' must be defined.");
        url_ = url_.replace("{access_token}", encodeURIComponent("" + access_token)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * DELETE ApiKey
     * @param authorization UBT token
     * @param keyId KeyId
     * @return OK
     */
    4(authorization: string, keyId: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/ApiKey/{KeyId}";
        if (keyId === undefined || keyId === null)
            throw new Error("The parameter 'keyId' must be defined.");
        url_ = url_.replace("{KeyId}", encodeURIComponent("" + keyId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process4(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process4(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IGetInvitedUsersUsingGETPlatformClient {
    /**
     * Gets user
     * @param authorization ABT and UBT tokens
     * @param id id
     * @param pGuid pGuid
     * @param strategy (optional) strategy ( roles or groups ). By default roles
     * @return User Obj returned.
     */
    1(authorization: string, id: string, pGuid: string, strategy?: string | null | undefined): Observable<any>;
}

@Injectable()
export class GetInvitedUsersUsingGETPlatformClient implements IGetInvitedUsersUsingGETPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Gets user
     * @param authorization ABT and UBT tokens
     * @param id id
     * @param pGuid pGuid
     * @param strategy (optional) strategy ( roles or groups ). By default roles
     * @return User Obj returned.
     */
    1(authorization: string, id: string, pGuid: string, strategy?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Organizations/{id}/OrgUser/{pGuid}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined.");
        url_ = url_.replace("{pGuid}", encodeURIComponent("" + pGuid)); 
        if (strategy !== undefined)
            url_ += "strategy=" + encodeURIComponent("" + strategy) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid request. Organization Id / pGuid invalid", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("User not found in the organization", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface ISaveUsingPOSTPlatformClient {
    /**
     * Save a permission
     * @param authorization ABT, JWT ABT tokens
     * @param permission permission
     * @return OK
     */
    1(authorization: string, permission: PermissionTO): Observable<any>;
}

@Injectable()
export class SaveUsingPOSTPlatformClient implements ISaveUsingPOSTPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Save a permission
     * @param authorization ABT, JWT ABT tokens
     * @param permission permission
     * @return OK
     */
    1(authorization: string, permission: PermissionTO): Observable<any> {
        let url_ = this.baseUrl + "/Permission/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permission);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IUpdateUsingPUTPlatformClient {
    /**
     * Update a permission
     * @param authorization JWT ABT token
     * @param id id
     * @param permission permission
     * @return OK
     */
    1(authorization: string, id: string, permission: PermissionTO): Observable<any>;
    /**
     * Update user details for pGuid
     * @param authorization ABT, UBT and PGA UBT tokens
     * @param user user
     * @return OK
     */
    3(authorization: string, user: UserTO): Observable<any>;
    /**
     * Update ApiKey
     * @param authorization UBT token
     * @param keyId KeyId
     * @param userAPIKeyMapTO userAPIKeyMapTO
     * @return OK
     */
    2(authorization: string, keyId: string, userAPIKeyMapTO: UserAPIKeyMapTO): Observable<any>;
}

@Injectable()
export class UpdateUsingPUTPlatformClient implements IUpdateUsingPUTPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Update a permission
     * @param authorization JWT ABT token
     * @param id id
     * @param permission permission
     * @return OK
     */
    1(authorization: string, id: string, permission: PermissionTO): Observable<any> {
        let url_ = this.baseUrl + "/Permission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permission);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Update user details for pGuid
     * @param authorization ABT, UBT and PGA UBT tokens
     * @param user user
     * @return OK
     */
    3(authorization: string, user: UserTO): Observable<any> {
        let url_ = this.baseUrl + "/Users/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process3(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process3(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Update ApiKey
     * @param authorization UBT token
     * @param keyId KeyId
     * @param userAPIKeyMapTO userAPIKeyMapTO
     * @return OK
     */
    2(authorization: string, keyId: string, userAPIKeyMapTO: UserAPIKeyMapTO): Observable<any> {
        let url_ = this.baseUrl + "/Users/ApiKey/{KeyId}";
        if (keyId === undefined || keyId === null)
            throw new Error("The parameter 'keyId' must be defined.");
        url_ = url_.replace("{KeyId}", encodeURIComponent("" + keyId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userAPIKeyMapTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process2(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process2(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Entity", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IGetJWTTokenUsingGETPlatformClient {
    /**
     * Get public RSA certs exposed in Jwks format
     * @return OK
     */
    1(): Observable<any>;
}

@Injectable()
export class GetJWTTokenUsingGETPlatformClient implements IGetJWTTokenUsingGETPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Get public RSA certs exposed in Jwks format
     * @return OK
     */
    1(): Observable<any> {
        let url_ = this.baseUrl + "/Public/Jwks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IGetRolesPlatformClient {
    /**
     * Get Roles defined for an Application
     * @param authorization JWT ABT token
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @return List of Roles
     */
    1(authorization: string, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Observable<any>;
}

@Injectable()
export class GetRolesPlatformClient implements IGetRolesPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Get Roles defined for an Application
     * @param authorization JWT ABT token
     * @param limit (optional) Page Size
     * @param name (optional) name
     * @param offset (optional) Offset into the table
     * @param sortBy (optional) property to sort by
     * @param sortDir (optional) Sort direction
     * @return List of Roles
     */
    1(authorization: string, limit?: number | null | undefined, name?: string | null | undefined, offset?: number | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Roles/?";
        if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&"; 
        if (sortDir !== undefined)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad request / Parsing error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal server error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface ISearchUsingGETPlatformClient {
    /**
     * Get the session details for the pGuid
     * @param authorization ABT, JWT ABT and PGA UBT tokens
     * @param pGuid pGuid
     * @return OK
     */
    1(authorization: string, pGuid: string): Observable<any>;
    /**
     * Users search api. Restrictions: rows = no of records (Maximum: 25 by default)
     * @param authorization ABT, UBT (Domain Admin) token
     * @param domain domain
     * @param rows rows
     * @param start start
     * @param company (optional) company
     * @param countrycode (optional) countrycode
     * @param firstname (optional) firstname
     * @param lastname (optional) lastname
     * @param title (optional) title
     * @param username (optional) username
     * @return OK
     */
    2(authorization: string, domain: string, rows: string, start: string, company?: string | null | undefined, countrycode?: string | null | undefined, firstname?: string | null | undefined, lastname?: string | null | undefined, title?: string | null | undefined, username?: string | null | undefined): Observable<any>;
}

@Injectable()
export class SearchUsingGETPlatformClient implements ISearchUsingGETPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Get the session details for the pGuid
     * @param authorization ABT, JWT ABT and PGA UBT tokens
     * @param pGuid pGuid
     * @return OK
     */
    1(authorization: string, pGuid: string): Observable<any> {
        let url_ = this.baseUrl + "/Session/?";
        if (pGuid === undefined || pGuid === null)
            throw new Error("The parameter 'pGuid' must be defined and cannot be null.");
        else
            url_ += "pGuid=" + encodeURIComponent("" + pGuid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Users search api. Restrictions: rows = no of records (Maximum: 25 by default)
     * @param authorization ABT, UBT (Domain Admin) token
     * @param domain domain
     * @param rows rows
     * @param start start
     * @param company (optional) company
     * @param countrycode (optional) countrycode
     * @param firstname (optional) firstname
     * @param lastname (optional) lastname
     * @param title (optional) title
     * @param username (optional) username
     * @return OK
     */
    2(authorization: string, domain: string, rows: string, start: string, company?: string | null | undefined, countrycode?: string | null | undefined, firstname?: string | null | undefined, lastname?: string | null | undefined, title?: string | null | undefined, username?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Users/Search?";
        if (domain === undefined || domain === null)
            throw new Error("The parameter 'domain' must be defined and cannot be null.");
        else
            url_ += "domain=" + encodeURIComponent("" + domain) + "&"; 
        if (rows === undefined || rows === null)
            throw new Error("The parameter 'rows' must be defined and cannot be null.");
        else
            url_ += "rows=" + encodeURIComponent("" + rows) + "&"; 
        if (start === undefined || start === null)
            throw new Error("The parameter 'start' must be defined and cannot be null.");
        else
            url_ += "start=" + encodeURIComponent("" + start) + "&"; 
        if (company !== undefined)
            url_ += "company=" + encodeURIComponent("" + company) + "&"; 
        if (countrycode !== undefined)
            url_ += "countrycode=" + encodeURIComponent("" + countrycode) + "&"; 
        if (firstname !== undefined)
            url_ += "firstname=" + encodeURIComponent("" + firstname) + "&"; 
        if (lastname !== undefined)
            url_ += "lastname=" + encodeURIComponent("" + lastname) + "&"; 
        if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&"; 
        if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process2(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process2(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IReloadCacheUsingPOSTPlatformClient {
    /**
     * {SessionTracker.reloadCache.APIOperation}
     * @param apiKey apiKey
     * @return OK
     */
    1(apiKey: string): Observable<any>;
}

@Injectable()
export class ReloadCacheUsingPOSTPlatformClient implements IReloadCacheUsingPOSTPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * {SessionTracker.reloadCache.APIOperation}
     * @param apiKey apiKey
     * @return OK
     */
    1(apiKey: string): Observable<any> {
        let url_ = this.baseUrl + "/SessionTracker/Cache/Reload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "apiKey": apiKey !== undefined && apiKey !== null ? "" + apiKey : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IGetUsersUsingGETPlatformClient {
    /**
     * Search users
     * @param authorization ABT, UBT token
     * @param domain domain
     * @param username username
     * @param includeExpired (optional) includeExpired
     * @return OK
     */
    1(authorization: string, domain: string, username: string, includeExpired?: string | null | undefined): Observable<any>;
}

@Injectable()
export class GetUsersUsingGETPlatformClient implements IGetUsersUsingGETPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Search users
     * @param authorization ABT, UBT token
     * @param domain domain
     * @param username username
     * @param includeExpired (optional) includeExpired
     * @return OK
     */
    1(authorization: string, domain: string, username: string, includeExpired?: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Users/?";
        if (domain === undefined || domain === null)
            throw new Error("The parameter 'domain' must be defined and cannot be null.");
        else
            url_ += "domain=" + encodeURIComponent("" + domain) + "&"; 
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined and cannot be null.");
        else
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        if (includeExpired !== undefined)
            url_ += "includeExpired=" + encodeURIComponent("" + includeExpired) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export interface IRotateUsingPUTPlatformClient {
    /**
     * Rotates ApiKey
     * @param authorization UBT token
     * @param keyId KeyId
     * @return OK
     */
    1(authorization: string, keyId: string): Observable<any>;
}

@Injectable()
export class RotateUsingPUTPlatformClient implements IRotateUsingPUTPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PLATFORM_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "platform.use1.informatics.testing-domain.illumina.com/platform-services-manager";
    }

    /**
     * Rotates ApiKey
     * @param authorization UBT token
     * @param keyId KeyId
     * @return OK
     */
    1(authorization: string, keyId: string): Observable<any> {
        let url_ = this.baseUrl + "/Users/ApiKey/Rotate/{KeyId}";
        if (keyId === undefined || keyId === null)
            throw new Error("The parameter 'keyId' must be defined.");
        url_ = url_.replace("{KeyId}", encodeURIComponent("" + keyId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process1(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected process1(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

export class ChildAppTO implements IChildAppTO {
    allowGrantClientCreds?: number | undefined;
    appType!: ChildAppTOAppType;
    clientId!: string;
    clientSecret?: string | undefined;
    iconURL?: string | undefined;
    name!: string;
    namespace?: string | undefined;
    ownerId!: string;
    ownerType!: ChildAppTOOwnerType;
    rURL?: string | undefined;
    scopeCategory?: string | undefined;
    scopes?: string | undefined;

    constructor(data?: IChildAppTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowGrantClientCreds = _data["allowGrantClientCreds"];
            this.appType = _data["appType"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.iconURL = _data["iconURL"];
            this.name = _data["name"];
            this.namespace = _data["namespace"];
            this.ownerId = _data["ownerId"];
            this.ownerType = _data["ownerType"];
            this.rURL = _data["rURL"];
            this.scopeCategory = _data["scopeCategory"];
            this.scopes = _data["scopes"];
        }
    }

    static fromJS(data: any): ChildAppTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChildAppTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowGrantClientCreds"] = this.allowGrantClientCreds;
        data["appType"] = this.appType;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["iconURL"] = this.iconURL;
        data["name"] = this.name;
        data["namespace"] = this.namespace;
        data["ownerId"] = this.ownerId;
        data["ownerType"] = this.ownerType;
        data["rURL"] = this.rURL;
        data["scopeCategory"] = this.scopeCategory;
        data["scopes"] = this.scopes;
        return data; 
    }
}

export interface IChildAppTO {
    allowGrantClientCreds?: number | undefined;
    appType: ChildAppTOAppType;
    clientId: string;
    clientSecret?: string | undefined;
    iconURL?: string | undefined;
    name: string;
    namespace?: string | undefined;
    ownerId: string;
    ownerType: ChildAppTOOwnerType;
    rURL?: string | undefined;
    scopeCategory?: string | undefined;
    scopes?: string | undefined;
}

export class CustomCredentialsTO implements ICustomCredentialsTO {
    authorizationCode?: string | undefined;
    creationDate?: Date | undefined;
    custom_credential_id?: number | undefined;
    domain?: string | undefined;
    expireson?: Date | undefined;
    lastupdateDate?: Date | undefined;
    username?: string | undefined;

    constructor(data?: ICustomCredentialsTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationCode = _data["authorizationCode"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.custom_credential_id = _data["custom_credential_id"];
            this.domain = _data["domain"];
            this.expireson = _data["expireson"] ? new Date(_data["expireson"].toString()) : <any>undefined;
            this.lastupdateDate = _data["lastupdateDate"] ? new Date(_data["lastupdateDate"].toString()) : <any>undefined;
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): CustomCredentialsTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomCredentialsTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationCode"] = this.authorizationCode;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["custom_credential_id"] = this.custom_credential_id;
        data["domain"] = this.domain;
        data["expireson"] = this.expireson ? this.expireson.toISOString() : <any>undefined;
        data["lastupdateDate"] = this.lastupdateDate ? this.lastupdateDate.toISOString() : <any>undefined;
        data["username"] = this.username;
        return data; 
    }
}

export interface ICustomCredentialsTO {
    authorizationCode?: string | undefined;
    creationDate?: Date | undefined;
    custom_credential_id?: number | undefined;
    domain?: string | undefined;
    expireson?: Date | undefined;
    lastupdateDate?: Date | undefined;
    username?: string | undefined;
}

export class DmapAuthRequestDto implements IDmapAuthRequestDto {
    encryptedPassword?: string | undefined;
    username?: string | undefined;

    constructor(data?: IDmapAuthRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.encryptedPassword = _data["encryptedPassword"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): DmapAuthRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DmapAuthRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encryptedPassword"] = this.encryptedPassword;
        data["username"] = this.username;
        return data; 
    }
}

export interface IDmapAuthRequestDto {
    encryptedPassword?: string | undefined;
    username?: string | undefined;
}

export class DomainSettingTO implements IDomainSettingTO {
    jwtExpirationInMinute?: number | undefined;
    timeout?: number | undefined;
    userApiKeyExpirationInDays?: number | undefined;
    userApiKeyLimit?: number | undefined;

    constructor(data?: IDomainSettingTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jwtExpirationInMinute = _data["jwtExpirationInMinute"];
            this.timeout = _data["timeout"];
            this.userApiKeyExpirationInDays = _data["userApiKeyExpirationInDays"];
            this.userApiKeyLimit = _data["userApiKeyLimit"];
        }
    }

    static fromJS(data: any): DomainSettingTO {
        data = typeof data === 'object' ? data : {};
        let result = new DomainSettingTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jwtExpirationInMinute"] = this.jwtExpirationInMinute;
        data["timeout"] = this.timeout;
        data["userApiKeyExpirationInDays"] = this.userApiKeyExpirationInDays;
        data["userApiKeyLimit"] = this.userApiKeyLimit;
        return data; 
    }
}

export interface IDomainSettingTO {
    jwtExpirationInMinute?: number | undefined;
    timeout?: number | undefined;
    userApiKeyExpirationInDays?: number | undefined;
    userApiKeyLimit?: number | undefined;
}

export class EmailFilterTO implements IEmailFilterTO {
    domainOnly?: number | undefined;
    domainid?: number | undefined;
    emailExtension?: string | undefined;
    emailExtensionId?: number | undefined;

    constructor(data?: IEmailFilterTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainOnly = _data["domainOnly"];
            this.domainid = _data["domainid"];
            this.emailExtension = _data["emailExtension"];
            this.emailExtensionId = _data["emailExtensionId"];
        }
    }

    static fromJS(data: any): EmailFilterTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailFilterTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainOnly"] = this.domainOnly;
        data["domainid"] = this.domainid;
        data["emailExtension"] = this.emailExtension;
        data["emailExtensionId"] = this.emailExtensionId;
        return data; 
    }
}

export interface IEmailFilterTO {
    domainOnly?: number | undefined;
    domainid?: number | undefined;
    emailExtension?: string | undefined;
    emailExtensionId?: number | undefined;
}

export class GlobalAppTO implements IGlobalAppTO {
    admin_url?: string | undefined;
    allowGrantClientCreds?: number | undefined;
    allowTrustedClaims?: number | undefined;
    allow_multiple_sessions?: number | undefined;
    allow_server_side_invalidation?: number | undefined;
    allowedCors?: string | undefined;
    allowedToProvision?: boolean | undefined;
    allowed_to_provision?: number | undefined;
    apiURL?: string | undefined;
    appColor?: string | undefined;
    appType?: string | undefined;
    app_url?: string | undefined;
    appid?: number | undefined;
    ccenabledApp?: boolean | undefined;
    client_id?: string | undefined;
    client_secret?: string | undefined;
    creationdate?: string | undefined;
    description?: string | undefined;
    enabled?: boolean | undefined;
    externalGrantedScopes?: string | undefined;
    iconURL?: string | undefined;
    isCCEnabledApp?: boolean | undefined;
    isClientCredentialsImpersonationSupported?: number | undefined;
    is_microservice?: number | undefined;
    jwtAlgo?: string | undefined;
    jwtExpirationInSeconds?: number | undefined;
    lastupdatedate?: string | undefined;
    logout_url?: string | undefined;
    name?: string | undefined;
    namespace?: string | undefined;
    oldClient_secret?: string | undefined;
    ownerEmail?: string | undefined;
    ownerId?: string | undefined;
    ownerType?: string | undefined;
    parentappId?: number | undefined;
    r_url?: string | undefined;
    region?: string | undefined;
    scopeCategory?: string | undefined;
    scopes?: string | undefined;
    scopesOld?: string | undefined;
    secretKeyGenerationTime?: string | undefined;
    thresholdLimitForJWTRefreshInSeconds?: number | undefined;
    tokenType?: string | undefined;
    url_pattern?: string | undefined;
    version?: string | undefined;

    constructor(data?: IGlobalAppTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.admin_url = _data["admin_url"];
            this.allowGrantClientCreds = _data["allowGrantClientCreds"];
            this.allowTrustedClaims = _data["allowTrustedClaims"];
            this.allow_multiple_sessions = _data["allow_multiple_sessions"];
            this.allow_server_side_invalidation = _data["allow_server_side_invalidation"];
            this.allowedCors = _data["allowedCors"];
            this.allowedToProvision = _data["allowedToProvision"];
            this.allowed_to_provision = _data["allowed_to_provision"];
            this.apiURL = _data["apiURL"];
            this.appColor = _data["appColor"];
            this.appType = _data["appType"];
            this.app_url = _data["app_url"];
            this.appid = _data["appid"];
            this.ccenabledApp = _data["ccenabledApp"];
            this.client_id = _data["client_id"];
            this.client_secret = _data["client_secret"];
            this.creationdate = _data["creationdate"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.externalGrantedScopes = _data["externalGrantedScopes"];
            this.iconURL = _data["iconURL"];
            this.isCCEnabledApp = _data["isCCEnabledApp"];
            this.isClientCredentialsImpersonationSupported = _data["isClientCredentialsImpersonationSupported"];
            this.is_microservice = _data["is_microservice"];
            this.jwtAlgo = _data["jwtAlgo"];
            this.jwtExpirationInSeconds = _data["jwtExpirationInSeconds"];
            this.lastupdatedate = _data["lastupdatedate"];
            this.logout_url = _data["logout_url"];
            this.name = _data["name"];
            this.namespace = _data["namespace"];
            this.oldClient_secret = _data["oldClient_secret"];
            this.ownerEmail = _data["ownerEmail"];
            this.ownerId = _data["ownerId"];
            this.ownerType = _data["ownerType"];
            this.parentappId = _data["parentappId"];
            this.r_url = _data["r_url"];
            this.region = _data["region"];
            this.scopeCategory = _data["scopeCategory"];
            this.scopes = _data["scopes"];
            this.scopesOld = _data["scopesOld"];
            this.secretKeyGenerationTime = _data["secretKeyGenerationTime"];
            this.thresholdLimitForJWTRefreshInSeconds = _data["thresholdLimitForJWTRefreshInSeconds"];
            this.tokenType = _data["tokenType"];
            this.url_pattern = _data["url_pattern"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): GlobalAppTO {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalAppTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["admin_url"] = this.admin_url;
        data["allowGrantClientCreds"] = this.allowGrantClientCreds;
        data["allowTrustedClaims"] = this.allowTrustedClaims;
        data["allow_multiple_sessions"] = this.allow_multiple_sessions;
        data["allow_server_side_invalidation"] = this.allow_server_side_invalidation;
        data["allowedCors"] = this.allowedCors;
        data["allowedToProvision"] = this.allowedToProvision;
        data["allowed_to_provision"] = this.allowed_to_provision;
        data["apiURL"] = this.apiURL;
        data["appColor"] = this.appColor;
        data["appType"] = this.appType;
        data["app_url"] = this.app_url;
        data["appid"] = this.appid;
        data["ccenabledApp"] = this.ccenabledApp;
        data["client_id"] = this.client_id;
        data["client_secret"] = this.client_secret;
        data["creationdate"] = this.creationdate;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["externalGrantedScopes"] = this.externalGrantedScopes;
        data["iconURL"] = this.iconURL;
        data["isCCEnabledApp"] = this.isCCEnabledApp;
        data["isClientCredentialsImpersonationSupported"] = this.isClientCredentialsImpersonationSupported;
        data["is_microservice"] = this.is_microservice;
        data["jwtAlgo"] = this.jwtAlgo;
        data["jwtExpirationInSeconds"] = this.jwtExpirationInSeconds;
        data["lastupdatedate"] = this.lastupdatedate;
        data["logout_url"] = this.logout_url;
        data["name"] = this.name;
        data["namespace"] = this.namespace;
        data["oldClient_secret"] = this.oldClient_secret;
        data["ownerEmail"] = this.ownerEmail;
        data["ownerId"] = this.ownerId;
        data["ownerType"] = this.ownerType;
        data["parentappId"] = this.parentappId;
        data["r_url"] = this.r_url;
        data["region"] = this.region;
        data["scopeCategory"] = this.scopeCategory;
        data["scopes"] = this.scopes;
        data["scopesOld"] = this.scopesOld;
        data["secretKeyGenerationTime"] = this.secretKeyGenerationTime;
        data["thresholdLimitForJWTRefreshInSeconds"] = this.thresholdLimitForJWTRefreshInSeconds;
        data["tokenType"] = this.tokenType;
        data["url_pattern"] = this.url_pattern;
        data["version"] = this.version;
        return data; 
    }
}

export interface IGlobalAppTO {
    admin_url?: string | undefined;
    allowGrantClientCreds?: number | undefined;
    allowTrustedClaims?: number | undefined;
    allow_multiple_sessions?: number | undefined;
    allow_server_side_invalidation?: number | undefined;
    allowedCors?: string | undefined;
    allowedToProvision?: boolean | undefined;
    allowed_to_provision?: number | undefined;
    apiURL?: string | undefined;
    appColor?: string | undefined;
    appType?: string | undefined;
    app_url?: string | undefined;
    appid?: number | undefined;
    ccenabledApp?: boolean | undefined;
    client_id?: string | undefined;
    client_secret?: string | undefined;
    creationdate?: string | undefined;
    description?: string | undefined;
    enabled?: boolean | undefined;
    externalGrantedScopes?: string | undefined;
    iconURL?: string | undefined;
    isCCEnabledApp?: boolean | undefined;
    isClientCredentialsImpersonationSupported?: number | undefined;
    is_microservice?: number | undefined;
    jwtAlgo?: string | undefined;
    jwtExpirationInSeconds?: number | undefined;
    lastupdatedate?: string | undefined;
    logout_url?: string | undefined;
    name?: string | undefined;
    namespace?: string | undefined;
    oldClient_secret?: string | undefined;
    ownerEmail?: string | undefined;
    ownerId?: string | undefined;
    ownerType?: string | undefined;
    parentappId?: number | undefined;
    r_url?: string | undefined;
    region?: string | undefined;
    scopeCategory?: string | undefined;
    scopes?: string | undefined;
    scopesOld?: string | undefined;
    secretKeyGenerationTime?: string | undefined;
    thresholdLimitForJWTRefreshInSeconds?: number | undefined;
    tokenType?: string | undefined;
    url_pattern?: string | undefined;
    version?: string | undefined;
}

export class IPFilterTO implements IIPFilterTO {
    domainIPId?: number | undefined;
    domainid?: number | undefined;
    ipaddress?: string | undefined;
    type?: string | undefined;

    constructor(data?: IIPFilterTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainIPId = _data["domainIPId"];
            this.domainid = _data["domainid"];
            this.ipaddress = _data["ipaddress"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): IPFilterTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPFilterTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainIPId"] = this.domainIPId;
        data["domainid"] = this.domainid;
        data["ipaddress"] = this.ipaddress;
        data["type"] = this.type;
        return data; 
    }
}

export interface IIPFilterTO {
    domainIPId?: number | undefined;
    domainid?: number | undefined;
    ipaddress?: string | undefined;
    type?: string | undefined;
}

export class OrganizationTO implements IOrganizationTO {
    applicationId?: string | undefined;
    company?: string | undefined;
    createdById?: string | undefined;
    createdOn?: string | undefined;
    description?: string | undefined;
    domainName?: string | undefined;
    domainUID?: string | undefined;
    founderFirstName?: string | undefined;
    founderId?: string | undefined;
    founderLastName?: string | undefined;
    iconUrl?: string | undefined;
    id?: string | undefined;
    isCollaborationAllowed?: number | undefined;
    location?: string | undefined;
    name?: string | undefined;
    ownerFirstName?: string | undefined;
    ownerId?: string | undefined;
    ownerLastName?: string | undefined;
    updatedOn?: string | undefined;

    constructor(data?: IOrganizationTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.company = _data["company"];
            this.createdById = _data["createdById"];
            this.createdOn = _data["createdOn"];
            this.description = _data["description"];
            this.domainName = _data["domainName"];
            this.domainUID = _data["domainUID"];
            this.founderFirstName = _data["founderFirstName"];
            this.founderId = _data["founderId"];
            this.founderLastName = _data["founderLastName"];
            this.iconUrl = _data["iconUrl"];
            this.id = _data["id"];
            this.isCollaborationAllowed = _data["isCollaborationAllowed"];
            this.location = _data["location"];
            this.name = _data["name"];
            this.ownerFirstName = _data["ownerFirstName"];
            this.ownerId = _data["ownerId"];
            this.ownerLastName = _data["ownerLastName"];
            this.updatedOn = _data["updatedOn"];
        }
    }

    static fromJS(data: any): OrganizationTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["company"] = this.company;
        data["createdById"] = this.createdById;
        data["createdOn"] = this.createdOn;
        data["description"] = this.description;
        data["domainName"] = this.domainName;
        data["domainUID"] = this.domainUID;
        data["founderFirstName"] = this.founderFirstName;
        data["founderId"] = this.founderId;
        data["founderLastName"] = this.founderLastName;
        data["iconUrl"] = this.iconUrl;
        data["id"] = this.id;
        data["isCollaborationAllowed"] = this.isCollaborationAllowed;
        data["location"] = this.location;
        data["name"] = this.name;
        data["ownerFirstName"] = this.ownerFirstName;
        data["ownerId"] = this.ownerId;
        data["ownerLastName"] = this.ownerLastName;
        data["updatedOn"] = this.updatedOn;
        return data; 
    }
}

export interface IOrganizationTO {
    applicationId?: string | undefined;
    company?: string | undefined;
    createdById?: string | undefined;
    createdOn?: string | undefined;
    description?: string | undefined;
    domainName?: string | undefined;
    domainUID?: string | undefined;
    founderFirstName?: string | undefined;
    founderId?: string | undefined;
    founderLastName?: string | undefined;
    iconUrl?: string | undefined;
    id?: string | undefined;
    isCollaborationAllowed?: number | undefined;
    location?: string | undefined;
    name?: string | undefined;
    ownerFirstName?: string | undefined;
    ownerId?: string | undefined;
    ownerLastName?: string | undefined;
    updatedOn?: string | undefined;
}

export class PasswordPolicyTO implements IPasswordPolicyTO {
    domainid?: number | undefined;
    lowerCaseRequired?: number | undefined;
    maxLogins?: number | undefined;
    minLength?: number | undefined;
    numRequired?: number | undefined;
    passwordChangeDuration?: number | undefined;
    passwordPolicyId?: number | undefined;
    policy?: string | undefined;
    resetLockout?: number | undefined;
    reusePassword?: number | undefined;
    specialCharRequired?: number | undefined;
    upperCaseRequired?: number | undefined;

    constructor(data?: IPasswordPolicyTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainid = _data["domainid"];
            this.lowerCaseRequired = _data["lowerCaseRequired"];
            this.maxLogins = _data["maxLogins"];
            this.minLength = _data["minLength"];
            this.numRequired = _data["numRequired"];
            this.passwordChangeDuration = _data["passwordChangeDuration"];
            this.passwordPolicyId = _data["passwordPolicyId"];
            this.policy = _data["policy"];
            this.resetLockout = _data["resetLockout"];
            this.reusePassword = _data["reusePassword"];
            this.specialCharRequired = _data["specialCharRequired"];
            this.upperCaseRequired = _data["upperCaseRequired"];
        }
    }

    static fromJS(data: any): PasswordPolicyTO {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordPolicyTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainid"] = this.domainid;
        data["lowerCaseRequired"] = this.lowerCaseRequired;
        data["maxLogins"] = this.maxLogins;
        data["minLength"] = this.minLength;
        data["numRequired"] = this.numRequired;
        data["passwordChangeDuration"] = this.passwordChangeDuration;
        data["passwordPolicyId"] = this.passwordPolicyId;
        data["policy"] = this.policy;
        data["resetLockout"] = this.resetLockout;
        data["reusePassword"] = this.reusePassword;
        data["specialCharRequired"] = this.specialCharRequired;
        data["upperCaseRequired"] = this.upperCaseRequired;
        return data; 
    }
}

export interface IPasswordPolicyTO {
    domainid?: number | undefined;
    lowerCaseRequired?: number | undefined;
    maxLogins?: number | undefined;
    minLength?: number | undefined;
    numRequired?: number | undefined;
    passwordChangeDuration?: number | undefined;
    passwordPolicyId?: number | undefined;
    policy?: string | undefined;
    resetLockout?: number | undefined;
    reusePassword?: number | undefined;
    specialCharRequired?: number | undefined;
    upperCaseRequired?: number | undefined;
}

export class PermissionTO implements IPermissionTO {
    createdOn?: string | undefined;
    description!: string;
    id?: string | undefined;
    name!: string;
    updatedOn?: string | undefined;

    constructor(data?: IPermissionTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.updatedOn = _data["updatedOn"];
        }
    }

    static fromJS(data: any): PermissionTO {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn;
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        data["updatedOn"] = this.updatedOn;
        return data; 
    }
}

export interface IPermissionTO {
    createdOn?: string | undefined;
    description: string;
    id?: string | undefined;
    name: string;
    updatedOn?: string | undefined;
}

export class RoleTO implements IRoleTO {
    appId?: string | undefined;
    appName?: string | undefined;
    createdOn?: string | undefined;
    default?: boolean | undefined;
    description?: string | undefined;
    id?: string | undefined;
    /** name */
    name!: string;
    permissions?: string[] | undefined;
    updatedOn?: string | undefined;

    constructor(data?: IRoleTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appName = _data["appName"];
            this.createdOn = _data["createdOn"];
            this.default = _data["default"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.updatedOn = _data["updatedOn"];
        }
    }

    static fromJS(data: any): RoleTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appName"] = this.appName;
        data["createdOn"] = this.createdOn;
        data["default"] = this.default;
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["updatedOn"] = this.updatedOn;
        return data; 
    }
}

export interface IRoleTO {
    appId?: string | undefined;
    appName?: string | undefined;
    createdOn?: string | undefined;
    default?: boolean | undefined;
    description?: string | undefined;
    id?: string | undefined;
    /** name */
    name: string;
    permissions?: string[] | undefined;
    updatedOn?: string | undefined;
}

export class ScopeRegistryTO implements IScopeRegistryTO {
    appId?: number | undefined;
    clientId?: string | undefined;
    createdOn?: string | undefined;
    globalAppTO?: GlobalAppTO | undefined;
    id?: number | undefined;
    scope?: string | undefined;
    scopeCategory?: string | undefined;
    updatedOn?: string | undefined;

    constructor(data?: IScopeRegistryTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.clientId = _data["clientId"];
            this.createdOn = _data["createdOn"];
            this.globalAppTO = _data["globalAppTO"] ? GlobalAppTO.fromJS(_data["globalAppTO"]) : <any>undefined;
            this.id = _data["id"];
            this.scope = _data["scope"];
            this.scopeCategory = _data["scopeCategory"];
            this.updatedOn = _data["updatedOn"];
        }
    }

    static fromJS(data: any): ScopeRegistryTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeRegistryTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["clientId"] = this.clientId;
        data["createdOn"] = this.createdOn;
        data["globalAppTO"] = this.globalAppTO ? this.globalAppTO.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["scope"] = this.scope;
        data["scopeCategory"] = this.scopeCategory;
        data["updatedOn"] = this.updatedOn;
        return data; 
    }
}

export interface IScopeRegistryTO {
    appId?: number | undefined;
    clientId?: string | undefined;
    createdOn?: string | undefined;
    globalAppTO?: GlobalAppTO | undefined;
    id?: number | undefined;
    scope?: string | undefined;
    scopeCategory?: string | undefined;
    updatedOn?: string | undefined;
}

export class ScopeTO implements IScopeTO {
    category?: string[] | undefined;
    name?: string | undefined;

    constructor(data?: IScopeTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ScopeTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IScopeTO {
    category?: string[] | undefined;
    name?: string | undefined;
}

export class UserAPIKeyMapTO implements IUserAPIKeyMapTO {
    isGlobal!: UserAPIKeyMapTOIsGlobal;
    name!: string;
    orgRole?: UserAPIKeyOrgRoleMapTO[] | undefined;

    constructor(data?: IUserAPIKeyMapTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isGlobal = _data["isGlobal"];
            this.name = _data["name"];
            if (Array.isArray(_data["orgRole"])) {
                this.orgRole = [] as any;
                for (let item of _data["orgRole"])
                    this.orgRole!.push(UserAPIKeyOrgRoleMapTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserAPIKeyMapTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserAPIKeyMapTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGlobal"] = this.isGlobal;
        data["name"] = this.name;
        if (Array.isArray(this.orgRole)) {
            data["orgRole"] = [];
            for (let item of this.orgRole)
                data["orgRole"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUserAPIKeyMapTO {
    isGlobal: UserAPIKeyMapTOIsGlobal;
    name: string;
    orgRole?: UserAPIKeyOrgRoleMapTO[] | undefined;
}

export class UserAPIKeyOrgRoleMapTO implements IUserAPIKeyOrgRoleMapTO {
    organizationId?: string | undefined;
    roleId?: string[] | undefined;

    constructor(data?: IUserAPIKeyOrgRoleMapTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["roleId"])) {
                this.roleId = [] as any;
                for (let item of _data["roleId"])
                    this.roleId!.push(item);
            }
        }
    }

    static fromJS(data: any): UserAPIKeyOrgRoleMapTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserAPIKeyOrgRoleMapTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.roleId)) {
            data["roleId"] = [];
            for (let item of this.roleId)
                data["roleId"].push(item);
        }
        return data; 
    }
}

export interface IUserAPIKeyOrgRoleMapTO {
    organizationId?: string | undefined;
    roleId?: string[] | undefined;
}

export class UserRoleMapTO implements IUserRoleMapTO {
    admin?: boolean | undefined;
    createdOn?: string | undefined;
    emailId?: string | undefined;
    roles?: string[] | undefined;
    updatedOn?: string | undefined;

    constructor(data?: IUserRoleMapTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.admin = _data["admin"];
            this.createdOn = _data["createdOn"];
            this.emailId = _data["emailId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.updatedOn = _data["updatedOn"];
        }
    }

    static fromJS(data: any): UserRoleMapTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleMapTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["admin"] = this.admin;
        data["createdOn"] = this.createdOn;
        data["emailId"] = this.emailId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["updatedOn"] = this.updatedOn;
        return data; 
    }
}

export interface IUserRoleMapTO {
    admin?: boolean | undefined;
    createdOn?: string | undefined;
    emailId?: string | undefined;
    roles?: string[] | undefined;
    updatedOn?: string | undefined;
}

export class UserTO implements IUserTO {
    activationdate?: string | undefined;
    collaborationType?: string | undefined;
    company?: string | undefined;
    countryCode?: string | undefined;
    createddate?: string | undefined;
    domain?: string | undefined;
    domainName?: string | undefined;
    domainUID?: string | undefined;
    domainid?: number | undefined;
    emailId?: string | undefined;
    expirationdate?: string | undefined;
    firstname?: string | undefined;
    isOwner?: boolean | undefined;
    lastname?: string | undefined;
    lastupdatedate?: string | undefined;
    locked?: number | undefined;
    login?: string | undefined;
    mustChangePassword?: boolean | undefined;
    pGuid?: string | undefined;
    password?: string | undefined;
    roles?: any | undefined;
    title?: string | undefined;
    userid?: number | undefined;
    username?: string | undefined;
    uuid?: string | undefined;
    uuidcreationdate?: Date | undefined;

    constructor(data?: IUserTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationdate = _data["activationdate"];
            this.collaborationType = _data["collaborationType"];
            this.company = _data["company"];
            this.countryCode = _data["countryCode"];
            this.createddate = _data["createddate"];
            this.domain = _data["domain"];
            this.domainName = _data["domainName"];
            this.domainUID = _data["domainUID"];
            this.domainid = _data["domainid"];
            this.emailId = _data["emailId"];
            this.expirationdate = _data["expirationdate"];
            this.firstname = _data["firstname"];
            this.isOwner = _data["isOwner"];
            this.lastname = _data["lastname"];
            this.lastupdatedate = _data["lastupdatedate"];
            this.locked = _data["locked"];
            this.login = _data["login"];
            this.mustChangePassword = _data["mustChangePassword"];
            this.pGuid = _data["pGuid"];
            this.password = _data["password"];
            this.roles = _data["roles"];
            this.title = _data["title"];
            this.userid = _data["userid"];
            this.username = _data["username"];
            this.uuid = _data["uuid"];
            this.uuidcreationdate = _data["uuidcreationdate"] ? new Date(_data["uuidcreationdate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationdate"] = this.activationdate;
        data["collaborationType"] = this.collaborationType;
        data["company"] = this.company;
        data["countryCode"] = this.countryCode;
        data["createddate"] = this.createddate;
        data["domain"] = this.domain;
        data["domainName"] = this.domainName;
        data["domainUID"] = this.domainUID;
        data["domainid"] = this.domainid;
        data["emailId"] = this.emailId;
        data["expirationdate"] = this.expirationdate;
        data["firstname"] = this.firstname;
        data["isOwner"] = this.isOwner;
        data["lastname"] = this.lastname;
        data["lastupdatedate"] = this.lastupdatedate;
        data["locked"] = this.locked;
        data["login"] = this.login;
        data["mustChangePassword"] = this.mustChangePassword;
        data["pGuid"] = this.pGuid;
        data["password"] = this.password;
        data["roles"] = this.roles;
        data["title"] = this.title;
        data["userid"] = this.userid;
        data["username"] = this.username;
        data["uuid"] = this.uuid;
        data["uuidcreationdate"] = this.uuidcreationdate ? this.uuidcreationdate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUserTO {
    activationdate?: string | undefined;
    collaborationType?: string | undefined;
    company?: string | undefined;
    countryCode?: string | undefined;
    createddate?: string | undefined;
    domain?: string | undefined;
    domainName?: string | undefined;
    domainUID?: string | undefined;
    domainid?: number | undefined;
    emailId?: string | undefined;
    expirationdate?: string | undefined;
    firstname?: string | undefined;
    isOwner?: boolean | undefined;
    lastname?: string | undefined;
    lastupdatedate?: string | undefined;
    locked?: number | undefined;
    login?: string | undefined;
    mustChangePassword?: boolean | undefined;
    pGuid?: string | undefined;
    password?: string | undefined;
    roles?: any | undefined;
    title?: string | undefined;
    userid?: number | undefined;
    username?: string | undefined;
    uuid?: string | undefined;
    uuidcreationdate?: Date | undefined;
}

/** membershipType */
export enum MembershipType {
    All = "all",
    Limited = "limited",
}

/** membershipType */
export enum MembershipType2 {
    All = "all",
    Limited = "limited",
}

export enum ChildAppTOAppType {
    Internal = "internal",
    External = "external",
    Microservice = "microservice",
}

export enum ChildAppTOOwnerType {
    User_or_workgroup = "user or workgroup",
}

export enum UserAPIKeyMapTOIsGlobal {
    _0 = 0,
    _1 = 1,
}

export class PlatformApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isPlatformApiException = true;

    static isPlatformApiException(obj: any): obj is PlatformApiException {
        return obj.isPlatformApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new PlatformApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}